import React, { useState, useEffect, useRef } from "react";
import Layout from "../../../components/layout/layout";
import {
  Download,
  Search,
  Filter,
  X,
  Clock,
  Pencil,
  Plus,
  Trash,
  Star,
  Check,
  Building2,
  NotepadText,
  Camera,
  Loader,
} from "lucide-react";
import { getFunctions, httpsCallable } from "firebase/functions";
import { useDispatch, useSelector } from "react-redux";
import csc from "countrycitystatejson";

import emtyimg from "../../../assets/image/setUpTeams.png";
import noActivityImg from "../../../assets/image/emtyimg.png";

import ViewModel from "../../../common/ViewModel/ViewModel"; // Import the ViewModel component
import FilterModelTeam from "../../Customer/Teams/FilterModelTeam"; // Import the FilterModelTeam component

import teamRoleMemberimg from "../../../assets/image/teamRoleMemberimg.png";
import { getNameFromEmail } from "../../../utils/common";
import { useAppState } from "../../../hooks/useAppState";
import {
  fetchAllTeamData,
  fetchTeamActivities,
  filterMembersTeams,
  setEnhancedMembers,
  addMemberToState,
  setCurrentTeam, // <-- import the action
  updateMemberAfterSave, // <-- import the new action
  setupCurrentTeamListener, // <-- import current team listener
  cleanupCurrentTeamListener, // <-- import current team cleanup
} from "../../../store/slices/teamSlice";
// Import firebase services for direct data fetching
import { db, storage } from "../../../config/firebase";
import {
  doc,
  getDoc,
  collection,
  query,
  where,
  getDocs,
  setDoc,
  updateDoc,
} from "firebase/firestore";
import { useAppSelector } from "../../../store/hooks";
import { AppDispatch, RootState } from "../../../store";

import { fetchUserOrganizations } from "../../../store/slices/orgSlice";
import { getTimestamp } from "../../Admin/directory/utils";
import { createNotification } from "../../../store/slices/notificationSlice";
import { fetchUserRatingAndReviews, logActivity } from "../../../store/profileSlice";
import { getStateFullName } from "../../../common/AddressControl/stateNameMapper";
import { getCountryFullName } from "../../../common/AddressControl/countryNameMapper";
import { getDownloadURL, ref, uploadBytes } from "firebase/storage";

const specialtyOptions = [
  "Full-service implementations",
  "Account setup",
  "Project-oriented workflows",

  "Templates",
  "Reporting",
  "Admin",
  "Security",
  "Customisation",
  "Integrations & APIs",
  "New user onboarding",
  "Disaster recovery",
  "Dashboard setup",
  "Data migration",
  "Others (Specify)",
];
interface FormData {
  fullName: string;
  email: string;
  ratePerMin: string;
  role: string;
  availability: boolean;
  specialities: {
    [key: string]: boolean;
  };
  otherSpecialties: string;
  orgName?: string;
  orgUrl?: string;
  taxId?: string;
  addressLine1?: string;
  addressLine2?: string;
  country?: string;
  state?: string;
  city?: string;
  zipCode?: string;
  teamName?: string;
}

const Teams = () => {
  const dispatch = useDispatch<AppDispatch>();
  const {
    members,
    filteredMembers,
filteredMembersLoading,
    status,
    currentTeam,
    teamActivities,
    activitiesLoading,
    activitiesError,
  } = useSelector((state: any) => state.team);
  const orgData = useAppSelector(
    (state: RootState) => state.organization.currentOrganization
  );
  // Add selectors for user ratings
  const userRatings = useSelector(
    (state: RootState) => state.profile.userRatings
  );
  const ratingsLoading = useSelector(
    (state: RootState) => state.profile.ratingsLoading
  );

  const { user } = useAppState();
  const [activeTab, setActiveTab] = useState("Directory");
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [activityCurrentPage, setActivityCurrentPage] = useState(1);
  // Use Redux loading state instead of local state
  const loading = status === 'loading' || status === 'idle';
  const [error, setError] = useState<string | null>(null);
  const itemsPerPage = 10;
  const [selectedMember, setSelectedMember] = useState<any>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [addMember, setAddMember] = useState(false);
  const [inviteSuccess, setInviteSuccess] = useState(false);
  const [email, setEmail] = useState("");
  const [role, setRole] = useState("");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  // Ref to detect outside clicks for dropdown
  const roleDropdownRef = useRef<HTMLDivElement | null>(null);

  // Close dropdown when clicking outside or pressing Escape
  useEffect(() => {
    if (!isDropdownOpen) return;

    const handleClickOutside = (event: MouseEvent | TouchEvent) => {
      const target = event.target as Node;
      if (roleDropdownRef.current && !roleDropdownRef.current.contains(target)) {
        setIsDropdownOpen(false);
      }
    };

    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside);
    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [isDropdownOpen]);
  const [viewModelOpen, setViewModelOpen] = useState(false); // Replace activityView with viewModelOpen to track ViewModel visibility
  const [selectedActivity, setSelectedActivity] = useState<any>(null);
  const [viewEditeModel, setViewEditeModel] = useState(false);
  const [filterViewModel, setFilterViewModel] = useState(false);
  const [setupTeamModel, setSetUpTeamModel] = useState(false);
  const [isInviting, setIsInviting] = useState(false);
  const [isInviteFormValid, setIsInviteFormValid] = useState(false);
  const [organizationData, setOrganizationData] = useState(null);
  const [loadingOrgData, setLoadingOrgData] = useState(false);
  const [teamSetupComplete, setTeamSetupComplete] = useState(false);
  const [isSubmittingTeam, setIsSubmittingTeam] = useState(false);
  const [viewData, setViewData] = useState<FormData>({
    fullName: "",
    email: "",
    ratePerMin: "",
    role: "Team Lead",
    availability: true,
    specialities: specialtyOptions.reduce((acc, option) => {
      acc[option] = false;
      return acc;
    }, {} as { [key: string]: boolean }),
    otherSpecialties: "",
    orgName: "",
    orgUrl: "",
    taxId: "",
    addressLine1: "",
    addressLine2: "",
    country: "",
    state: "",
    city: "",
    zipCode: "",
    teamName: "",
  });
  // Add state variables to track viewed and edited member IDs
  const [viewedMemberId, setViewedMemberId] = useState<string | null>(null);
  const [editedMemberId, setEditedMemberId] = useState<string | null>(null);
  // Add state variable to track viewed activity ID
  const [viewedActivityId, setViewedActivityId] = useState<string | null>(null);
  // Add state for country and state management
  const [countries, setCountries] = useState<any[]>([]);
  const [states, setStates] = useState<any[]>([]);
  const [customSpecialtyError, setCustomSpecialtyError] = useState<string>("");
  const[uploadingImage,setUploadingImage] = useState(false);

  // Add state for custom specialties
  const [customSpecialties, setCustomSpecialties] = useState<string[]>([]);

  // Add state for account status management
  const [statusLoading, setStatusLoading] = useState(false);

  const [formData, setFormData] = useState<FormData>({
    fullName: "",
    email: "",
    ratePerMin: "",
    role: "Team Lead",
    availability: true,
    specialities: specialtyOptions.reduce((acc, option) => {
      acc[option] = false;
      return acc;
    }, {} as { [key: string]: boolean }),
    otherSpecialties: "",
    orgName: "",
    orgUrl: "",
    taxId: "",
    addressLine1: "",
    addressLine2: "",
    country: "",
    state: "",
    city: "",
    zipCode: "",
    teamName: "",
  });

  const roles = [
    { label: "Team Lead", value: "teamLead" },
    { label: "Team Member", value: "teamMember" },
  ];

  const [formErrors, setFormErrors] = useState({
    email: "",
    role: "",
    general: "",
  });
  // 1. Define the function somewhere in your component file or a utils file
  function formatRole(role) {
    switch (role) {
      case "expert_owner":
        return "Team Owner";
      case "expert_team_lead":
        return "Team Lead";
      case "expert_team_member":
        return "Team Member";
      default:
        return "Expert";
    }
  }
  // Fetch org names when selectedActivity changes
  const [expertOrgName, setExpertOrgName] = useState<string>("");
  const [expertTeamName, setExpertTeamName] = useState<string>("");
  const [customerOrgName, setCustomerOrgName] = useState<string>("");
  const [customerTeamName, setCustomerTeamName] = useState<string>("");
  useEffect(() => {
    const fetchOrgNames = async () => {
      setExpertOrgName("");
      setCustomerOrgName("");
      setExpertTeamName("");
      setCustomerTeamName("");
      if (selectedActivity) {
        // Fetch expert org
        const expertOrgId = selectedActivity?.expertOrganizationId;
        if (expertOrgId) {
          try {
            const orgRef = doc(db, "organizations", expertOrgId);
            const orgSnap = await getDoc(orgRef);
            if (orgSnap.exists()) {
              setExpertOrgName(orgSnap.data().name || "");
              setExpertTeamName(orgSnap.data().teamName || "");
            }
          } catch (e) {
            setExpertOrgName("");
          }
        }
        // Fetch customer org
        const customerOrgId = selectedActivity?.customerOrganizationId;
        if (customerOrgId) {
          try {
            const orgRef = doc(db, "organizations", customerOrgId);
            const orgSnap = await getDoc(orgRef);
            if (orgSnap.exists()) {
              setCustomerOrgName(orgSnap.data().name || "");
              setCustomerTeamName(orgSnap.data().teamName || "");
            }
          } catch (e) {
            setCustomerOrgName("");
          }
        }
      }
    };
    fetchOrgNames();
  }, [selectedActivity]);

  useEffect(() => {
    // Update isInviteFormValid when email or role changes
    setIsInviteFormValid(email.trim() !== "" && role !== "");
  }, [email, role]); // Fetch organization data when component mounts

  // Load countries on component mount
  useEffect(() => {
    try {
      const countryList = csc.getCountries();
      console.log("Country data structure:", countryList);
      // Ensure countryList is an array and has the expected structure
      if (Array.isArray(countryList)) {
        setCountries(countryList);
      } else {
        console.warn("Countries data is not in expected format:", countryList);
        setCountries([]);
      }
    } catch (error) {
      console.error("Error loading countries:", error);
      setCountries([]);
    }
  }, []);

  // Handle state loading when formData.country changes
  useEffect(() => {
    if (formData.country) {
      try {
        const selectedCountry = csc.getCountryByShort(formData.country);
        const statesData = selectedCountry?.states || {};

        let statesList: string[] = [];

        // Handle different data formats from the library
        if (Array.isArray(statesData)) {
          statesList = statesData;
        } else if (typeof statesData === "object" && statesData !== null) {
          statesList = Object.keys(statesData);
        } else {
          console.warn(
            "States data is neither array nor object for country:",
            formData.country,
            statesData
          );
          statesList = [];
        }

        setStates(statesList);
        console.log(
          "States loaded for country",
          formData.country,
          ":",
          statesList.length,
          "states"
        );
      } catch (error) {
        console.error(
          "Error loading states for country:",
          formData.country,
          error
        );
        setStates([]);
      }
    } else {
      setStates([]);
    }
  }, [formData.country]);

  // Data is already being fetched in App.tsx, just display loading state if needed
  useEffect(() => {
    if (status === 'idle' && user?.uid && user?.orgId) {
      console.log("Fetching organization with:", {
        uid: user.uid,
        orgId: user.orgId,
      });
      dispatch(
        fetchUserOrganizations({ uid: user.uid, orgId: user.orgId }) as any
      );
      // Only fetch team data if not already loaded
      dispatch(
        fetchAllTeamData({
          orgId: user.orgId,
          userId: user.uid,
          currentId: user.uid,
          userRole: user.uiRole,
        })
      );
    }
  }, [dispatch, user?.uid, user?.orgId, user?.uiRole, status]);

  // Function to check if any filters are currently active
  const hasActiveFilters = () => {
    return (
      filterCriteria.status !== "" ||
      filterCriteria.role !== "" ||
      filterCriteria.walletRange.length > 0 ||
      filterCriteria.amountRange.length > 0 ||
      filterCriteria.customWalletMin !== "" ||
      filterCriteria.customWalletMax !== "" ||
      filterCriteria.customAmountMin !== "" ||
      filterCriteria.customAmountMax !== ""
    );
  };
  // Fetch organization data when setup team modal opens
  useEffect(() => {
    const fetchOrganizationData = async () => {
      if (setupTeamModel && user?.orgId) {
        setLoadingOrgData(true);
        try {
          const orgRef = doc(db, "organizations", user.orgId);
          const orgSnapshot = await getDoc(orgRef);

          if (orgSnapshot.exists()) {
            const orgData = orgSnapshot.data();
            setOrganizationData(orgData as any);
            // Pre-populate form data with org details (read-only display)
            setFormData((prevData) => ({
              ...prevData,
              orgName: orgData.name || "",
              orgUrl: orgData.url || "",
              teamName: orgData.teamName || "",
              taxId: orgData.taxId || "",
              addressLine1: orgData.billingAddress?.address_1 || "",
              addressLine2: orgData.billingAddress?.address_2 || "",
              country: orgData.billingAddress?.country || "",
              state: orgData.billingAddress?.state || "",
              city: orgData.billingAddress?.city || "",
              zipCode: orgData.billingAddress?.postcode || "",
            }));
          }
        } catch (error) {
          console.error("Error fetching organization data:", error);
        } finally {
          setLoadingOrgData(false);
        }
      }
    };

    fetchOrganizationData();
  }, [setupTeamModel, user?.orgId]);
  const [sections, setSections] = useState({
    status: true,
    role: true,
    wallet: true,
    amount: true,
    rating: true,
  });
  const [customWallet, setCustomWallet] = useState(false);
  const [customAmount, setCustomAmount] = useState(false);
  const [activitySearchTerm, setActivitySearchTerm] = useState("");

  const [filterCriteria, setFilterCriteria] = useState({
    status: "",
    role: "",
    walletRange: [] as string[],
    amountRange: [] as string[],
    customWalletMin: "",
    customWalletMax: "",
    customAmountMin: "",
    customAmountMax: "",
    rating: "",
  });

 
  const handleInviteMember = async () => {
    try {
      setFormErrors({ email: "", role: "", general: "" });
      setIsInviting(true);

      // Validate inputs
      if (!email.trim()) {
        setFormErrors((prev) => ({ ...prev, email: "Email is required" }));
        setIsInviting(false);
        return;
      }

      if (!role) {
        setFormErrors((prev) => ({ ...prev, role: "Role is required" }));
        setIsInviting(false);
        return;
      }

      // Get Firebase Functions instance
      const functions = getFunctions();

      // Create reference to your Cloud Function
      const createInvitationFunc = httpsCallable(functions, "createInvitation");

      // Prepare the data to send to the function
      const invitationData = {
        orgId: user?.orgId, // Use user's current org ID if available
        firstName: getNameFromEmail(email), // Simple extraction of name from email
        email: email,
        invitedName: user?.name,
        role: user?.role,
        teamRole:
          role === "teamLead" ? "expert_team_lead" : "expert_team_member",
        teamId: orgData?.owner?.owner, // Optional, leave empty to use default team
      };

      // Call the function
      const result = await createInvitationFunc(invitationData);

      // Immediately add the new member to state for instant UI feedback
      const newMember = {
        id: result.data?.invitationId || Date.now().toString(), // fallback if no id
        uid: "", // Not yet registered
        status: "invited",
        initials: getNameFromEmail(email).substring(0, 2).toUpperCase(),
        name: getNameFromEmail(email),
        role: invitationData.teamRole,
        email: email,
        sessions: "0",
        lastActivity: "",
        lastActivitycustomer: "",
        lastActivityexpert: "",
        wallet: "$0.00",
        totalSpent: "$0.00",
        avatar: null,
        isOwner: false,
        invitedById: orgData?.owner?.owner || user?.uid,
        invitedByName: user?.name,
        invitationId: result.data?.invitationId || "",
      };
      dispatch(addMemberToState(newMember));
         // --- Add notification for Team Member or Team Lead added ---
            dispatch(
              createNotification({
                userId: user?.uid,
                userEmail: user?.email || "",
                message:
                  invitationData.teamRole === "customer_team_lead"
                    ? `Team Lead "${newMember.email}" has been invited`
                    : `Team Member "${newMember.email}" has been invited`,
                trigger:
                  invitationData.teamRole === "customer_team_lead"
                    ? "team_lead_added"
                    : "team_member_added",
                triggeredBy: user?.uid,
                meta: {
                  invitedEmail: newMember.email,
                  invitedRole: invitationData.teamRole,
                  invitationId: newMember.invitationId,
                },
              })
            );
      // Optionally re-run filter if search/filter is active
      if (hasActiveFilters()) {
        dispatch(
          filterMembersTeams({
            searchTerm,
            userRole: user.teamRole,
            userId: user.teamId,
          })
        );
      }

      await dispatch(
        fetchAllTeamData({
          orgId: user.orgId,
          userId: user.teamId,
          currentId: user?.uid,
          userRole: user?.teamRole,
        })
      );
      // Handle the result
      console.log("Invitation created:", result.data);
      setEmail("");
      setRole("");
      setAddMember(false);
      setInviteSuccess(true);
    } catch (error: any) {
      console.error("Error creating invitation:", error);
      setFormErrors((prev) => ({
        ...prev,
        general: error.message || "Failed to send invitation",
      }));
    } finally {
      setIsInviting(false);
    }
  };
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmittingTeam(true);
    setError(null);

    try {
      // Create team document in Firestore
      if (user?.uid && user?.orgId && formData.teamName) {
        const teamRef = doc(db, "organizations", user.orgId, "teams", user.uid);
        const updatedTeam = {
          ...currentTeam,
          teamName: formData.teamName,
        };

        // Update team in Redux store
        dispatch(setCurrentTeam(updatedTeam));
        const teamData = {
          teamName: formData.teamName,
          default: true,
          users: [],
          createdAt: new Date().toISOString(),
          updatedAt: new Date().toISOString(),
        };

        await setDoc(teamRef, teamData);

        // Update organization document with team details
        const orgRef = doc(db, "organizations", user.orgId);
        const orgSnapshot = await getDoc(orgRef);
        if (orgSnapshot.exists()) {
          const currentOrgData = orgSnapshot.data();

          // Prepare update data, only including fields that have values
          const updateData: any = {
            updatedAt: new Date().toISOString(),
          };
          if (formData.teamName?.trim()) {
            updateData.teamName = formData.teamName.trim();
          } else if (currentOrgData.teamName) {
            updateData.teamName = currentOrgData.teamName;
          }
          // Only add fields if they have values
          if (formData.orgName?.trim()) {
            updateData.name = formData.orgName.trim();
          } else if (currentOrgData.name) {
            updateData.name = currentOrgData.name;
          }

          if (formData.orgUrl?.trim()) {
            updateData.url = formData.orgUrl.trim();
          } else if (currentOrgData.url) {
            updateData.url = currentOrgData.url;
          }
          if (formData.teamName?.trim()) {
            updateData.teamName = formData.teamName.trim();
          } else if (currentOrgData.teamName) {
            updateData.teamName = currentOrgData.teamName;
          }

          if (formData.taxId?.trim()) {
            updateData.taxId = formData.taxId.trim();
          } else if (currentOrgData.taxId) {
            updateData.taxId = currentOrgData.taxId;
          } else if (currentOrgData.id) {
            updateData.taxId = currentOrgData.id;
          }

          // Handle billing address with proper undefined checks
          const currentBillingAddress = currentOrgData.billingAddress || {};
          const billingAddress: any = {};

          if (formData.addressLine1?.trim()) {
            billingAddress.address_1 = formData.addressLine1.trim();
          } else if (currentBillingAddress.address_1) {
            billingAddress.address_1 = currentBillingAddress.address_1;
          }

          if (formData.addressLine2?.trim()) {
            billingAddress.address_2 = formData.addressLine2.trim();
          } else if (currentBillingAddress.address_2) {
            billingAddress.address_2 = currentBillingAddress.address_2;
          }

          if (formData.country?.trim()) {
            billingAddress.country = formData.country.trim();
          } else if (currentBillingAddress.country) {
            billingAddress.country = currentBillingAddress.country;
          }

          if (formData.state?.trim()) {
            billingAddress.state = formData.state.trim();
          } else if (currentBillingAddress.state) {
            billingAddress.state = currentBillingAddress.state;
          }

          if (formData.city?.trim()) {
            billingAddress.city = formData.city.trim();
          } else if (currentBillingAddress.city) {
            billingAddress.city = currentBillingAddress.city;
          }

          if (formData.zipCode?.trim()) {
            billingAddress.postcode = formData.zipCode.trim();
          } else if (currentBillingAddress.postcode) {
            billingAddress.postcode = currentBillingAddress.postcode;
          }

          // Only add billingAddress if it has at least one property
          if (Object.keys(billingAddress).length > 0) {
            updateData.billingAddress = {
              ...currentBillingAddress,
              ...billingAddress,
            };
          }

          await setDoc(orgRef, updateData, { merge: true });
        } // Show success notification

        // Show success notification
        dispatch(
          createNotification({
            userId: user.uid,
            userEmail: user.email || "",
            message: `Team "${formData.teamName}" has been successfully created`,
            trigger: "team_created",
            triggeredBy: user.uid,
          })
        );
        // Refresh team data
        await dispatch(
          fetchAllTeamData({
            orgId: user?.orgId,
            userId: user?.teamId,
            currentId: user?.uid,
            userRole: user?.teamRole,
          })
        );

        // Filter members after fetching team data
        if (user) {
          dispatch(
            filterMembersTeams({
              searchTerm,
              userRole: user?.teamRole,
              userId: user?.teamId,
            })
          );
        }

        // Set team setup complete state
        setTeamSetupComplete(true);

        handleClose();
      }
    } catch (error) {
      console.error("Error creating team:", error);
      setError("Failed to create team. Please try again.");
    } finally {
      setIsSubmittingTeam(false);
    }
  };

  const handleSubmitInvite = (e: React.FormEvent) => {
    e.preventDefault();
    if (isInviteFormValid && !isInviting) {
      handleInviteMember();
    }
  };
  console.log(selectedMember, "selectedMember");
  const onClose = () => {
    setAddMember(false);
    setEmail("");
    setRole("");
    setIsDropdownOpen(false);
    setViewedMemberId(null); // Reset viewed member ID
  };
  const handleActivityView = (activity: any) => {
    // Set the viewed activity ID for highlighting
    setViewedActivityId(activity.id || activity.activityId);
    // Fetch ratings for both expert and customer
    if (activity.expertId || activity.expertData?.id) {
      dispatch(
        fetchUserRatingAndReviews({
          userId: activity.expertId || activity.expertData.id,
          role: "Expert",
        })
      );
    }

    if (activity.customerId || activity.customerData?.id) {
      dispatch(
        fetchUserRatingAndReviews({
          userId: activity.customerId || activity.customerData.id,
          role: "Customer",
        })
      );
    }

    setSelectedActivity(activity);
    // Set the selected ID from the activity if it exists, otherwise use a default
    // const activityId = activity.id || 1;
    // setSelectedActivity({ ...activity, id: activityId });
    setViewModelOpen(true); // Open the ViewModel instead of setting activityView
  };

  const handleActivityPageChange = (pageNumber: number) => {
    setActivityCurrentPage(pageNumber);
  };

  const handlePageChange = (pageNumber: number) => {
    setCurrentPage(pageNumber);
  };

  const handleActivityClose = () => {
    setViewModelOpen(false);
    setSelectedActivity(null);
    setViewedActivityId(null); // Reset viewed activity ID
  };

 

  // Add useEffect to handle custom specialties for selected member
  useEffect(() => {
    if (
      selectedMember?.profileData?.specialities &&
      Array.isArray(selectedMember.profileData.specialities)
    ) {
      // Filter out predefined specialties to get only custom ones
      const userCustomSpecialties =
        selectedMember.profileData.specialities.filter(
          (specialty) => !specialtyOptions.includes(specialty)
        );
      setCustomSpecialties(userCustomSpecialties);

      // Update formData to include custom specialties
      if (userCustomSpecialties.length > 0) {
        const updatedSpecialities = { ...formData.specialities };
        userCustomSpecialties.forEach((customSpecialty) => {
          updatedSpecialities[customSpecialty] = true;
        });
        setFormData((prev) => ({
          ...prev,
          specialities: updatedSpecialities,
        }));
      }
    }
  }, [selectedMember?.profileData?.specialities]);

  // Create merged specialties array (similar to DirectoryComponents)
  const mergedSpecialties = [
    ...specialtyOptions.filter((s) => s !== "Others (Specify)"),
    ...customSpecialties,
    "Others (Specify)", // Add "Others (Specify)" at the end
  ];



  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  // Checkbox change handler for specialities
  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, checked } = e.target;

    setFormData({
      ...formData,
      specialities: {
        ...formData.specialities,
        [name]: checked,
      },
    });

    // Clear otherSpecialties text when "Others (Specify)" is unchecked
    if (name === "Others (Specify)" && !checked) {
      setFormData((prev) => ({
        ...prev,
        specialities: {
          ...prev.specialities,
          [name]: false,
        },
        otherSpecialties: "",
      }));
    }

    // Also update the selectedMember specialities for immediate UI feedback
    if (selectedMember) {
      let updatedSpecialities = [
        ...(selectedMember.profileData?.specialities || []),
      ];

      if (checked) {
        // Add specialty if checked and not already present
        if (!updatedSpecialities.includes(name)) {
          updatedSpecialities.push(name);
        }
      } else {
        // Remove specialty if unchecked
        updatedSpecialities = updatedSpecialities.filter(
          (spec) => spec !== name
        );

        // If unchecking "Others (Specify)", also remove any "Others:" entries
        if (name === "Others (Specify)") {
          updatedSpecialities = updatedSpecialities.filter(
            (spec) => !spec.startsWith("Others:")
          );
        }
      }

      setSelectedMember({
        ...selectedMember,
        profileData: {
          ...selectedMember.profileData,
          specialities: updatedSpecialities,
        },
      });

      // Update custom specialties if this is a custom one
      if (!specialtyOptions.includes(name) && name !== "Others (Specify)") {
        if (checked) {
          setCustomSpecialties((prev) => [...prev, name]);
        } else {
          setCustomSpecialties((prev) => prev.filter((spec) => spec !== name));
        }
      }
    }
  };


  const [isSavingMember, setIsSavingMember] = useState(false);
  const onSave = async () => {
    if (!editedMemberId || isSavingMember) return;

    // Validate "Others (Specify)" field
    if (
      formData.specialities["Others (Specify)"] &&
      !formData.otherSpecialties.trim()
    ) {
      setCustomSpecialtyError(
        "Please specify your other specialties when 'Others (Specify)' is selected"
      );
      return;
    }

    setIsSavingMember(true);
    setCustomSpecialtyError("");
    try {
      // Get selected specialities
      const selectedSpecialities = Object.entries(formData.specialities)
        .filter(([_, checked]) => checked)
        .map(([specialty, _]) => specialty);

      // Handle "Others (Specify)" field - replace with actual custom specialty text
      if (
        formData.specialities["Others (Specify)"] &&
        formData.otherSpecialties.trim()
      ) {
        const otherIndex = selectedSpecialities.indexOf("Others (Specify)");
        if (otherIndex !== -1) {
          selectedSpecialities[otherIndex] = formData.otherSpecialties.trim();
        }
      }

      // Prepare updated data
      const updatedProfileData: any = {
        name: formData.fullName,
        ratePerMinute: formData.ratePerMin,
        teamRole: formData.role,
        specialities: selectedSpecialities,
        availability: formData.availability,
        updatedAt: new Date().toISOString(),
        updatedBy: user?.email || "admin",
      };

      // Update profiles collection (query by userId)
      const profilesRef = collection(db, "profiles");
      const q = query(profilesRef, where("userId", "==", editedMemberId));
      const querySnapshot = await getDocs(q);
      if (!querySnapshot.empty) {
        const profileDocRef = querySnapshot.docs[0].ref;
        await updateDoc(profileDocRef, updatedProfileData);
      }

      // Update users collection (doc id = editedMemberId)
      const userDocRef = doc(db, "users", editedMemberId);
      const userUpdate: any = {
        name: formData.fullName,
        teamRole: formData.role,
        uiRole: formData.role,
        specialities: selectedSpecialities,
        availability: formData.availability,
        updatedAt: new Date().toISOString(),
        updatedBy: user?.email || "admin",
      };

      // Add otherSpecialties only if "Others (Specify)" was selected and text was provided
      if (
        formData.specialities["Others (Specify)"] &&
        formData.otherSpecialties.trim()
      ) {
        userUpdate.otherSpecialities = formData.otherSpecialties.trim();
      }

      await updateDoc(userDocRef, userUpdate);

      // Update Redux state immediately using the new action
      await dispatch(
        updateMemberAfterSave({
          memberId: editedMemberId,
          updatedData: {
            name: formData.fullName,
            ratePerMin: formData.ratePerMin,
            role: formData.role,
            specialities: selectedSpecialities,
            availability: formData.availability,
          },
        })
      );

      console.log("Member updated successfully");
      setViewEditeModel(false);
      setEditedMemberId(null); // Reset edited member ID
    } catch (error) {
      console.error("Error updating member:", error);
      // Optionally, show an error message
    } finally {
      setIsSavingMember(false);
    }
  };
  const handleEditMember = (member: any) => {
    setEditedMemberId(member.id || member.uid);
    setSelectedMember(member);
    // Fetch additional profile data for proper specialties handling
    let profileSpecialities = [];
    let otherSpecialtyText = "";

    if (
      member?.profileData?.specialities &&
      Array.isArray(member.profileData.specialities)
    ) {
      profileSpecialities = member.profileData.specialities;
    }

    // Filter out predefined specialties to get only custom ones
    const userCustomSpecialties = profileSpecialities.filter(
      (specialty) => !specialtyOptions.includes(specialty)
    );
    setCustomSpecialties(userCustomSpecialties);

    // Create specialities object based on mergedSpecialties array
    const specialitiesObject: { [key: string]: boolean } = {};
    const allSpecialties = [
      ...specialtyOptions.filter((s) => s !== "Others (Specify)"),
      ...userCustomSpecialties,
      "Others (Specify)",
    ];

    allSpecialties.forEach((option) => {
      // Check if this specialty is in the member's profile data
      const isSelected = profileSpecialities.includes(option) || false;
      specialitiesObject[option] = isSelected;
    });

    // Handle "Others (Specify)" - check if there's a custom specialty that starts with "Others:"
    const othersSpecialty = profileSpecialities.find(
      (spec: string) =>
        spec.startsWith("Others:") || spec === "Others (Specify)"
    );

    if (othersSpecialty && othersSpecialty.startsWith("Others:")) {
      specialitiesObject["Others (Specify)"] = true;
      otherSpecialtyText = othersSpecialty.replace("Others: ", "");
    } else if (member?.profileData?.otherSpecialties) {
      // Check for otherSpecialties field in profile data
      specialitiesObject["Others (Specify)"] = true;
      otherSpecialtyText = member.profileData.otherSpecialties;
    }
    console.log(" member.profileData?.teamRole", member.profileData?.teamRole);

    setFormData({
      ...formData,
      fullName: member.name,
      email: member.email,
      ratePerMin: member.profileData?.ratePerMinute,
      role: member.profileData?.teamRole,
      availability: member?.profileData?.availability === true,
      specialities: specialitiesObject,
      otherSpecialties: otherSpecialtyText,
    });
    setViewEditeModel(true);
  };

  // Function to determine if row should be highlighted
  const shouldHighlightRow = (member: any) => {
    const memberId = member.id || member.uid;
    return memberId === viewedMemberId || memberId === editedMemberId;
  };

  // Function to check if activity row should be highlighted
  const shouldHighlightActivityRow = (activity: any) => {
    const activityId = activity.id || activity.activityId;
    return activityId === viewedActivityId;
  };

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });

    // Handle state loading when country changes
    if (name === "country" && value) {
      try {
        const selectedCountry = csc.getCountryByShort(value);
        const statesData = selectedCountry?.states || {};

        let statesList: string[] = [];

        // Handle different data formats from the library
        if (Array.isArray(statesData)) {
          statesList = statesData;
        } else if (typeof statesData === "object" && statesData !== null) {
          statesList = Object.keys(statesData);
        } else {
          console.warn(
            "States data is neither array nor object for country:",
            value,
            statesData
          );
          statesList = [];
        }

        setStates(statesList);

        // Reset the state field when country changes
        setFormData((prev) => ({
          ...prev,
          [name]: value,
          state: "",
        }));
      } catch (error) {
        console.error("Error loading states for country:", value, error);
        setStates([]);
      }
    } else if (name === "country" && !value) {
      // Clear states when no country is selected
      setStates([]);
      setFormData((prev) => ({
        ...prev,
        [name]: value,
        state: "",
      }));
    }
  };

  const handleSetupTeamClick = () => {
    setSetUpTeamModel(true);
  };

  const handleActivityEditFromViewModel = (data: any) => {
    // Update the selected activity with the new data from ViewModel
    setSelectedActivity(data);

    // Re-fetch activities to ensure data consistency
    if (
      user?.uid &&
      user?.orgId &&
      (user?.uiRole || user?.teamRole) &&
      currentTeam
    ) {
      dispatch(
        fetchTeamActivities({
          userRole: user.uiRole || user.teamRole,
          orgId: user.orgId,
          userId: user.teamId,
          currentTeam: currentTeam,
        })
      );
    }

    // Keep ViewModel open to show updated data
    setViewModelOpen(true);
  };
     const handleImageUpload = async (
      event: React.ChangeEvent<HTMLInputElement>
    ) => {
      if (!event.target.files || !selectedMember.id ) return;
  
      const file = event.target.files[0];
      if (!file) return;
  
      try {
        setUploadingImage(true);
  
        // Create storage reference
        const storageRef = ref(storage, `profileImages/${selectedMember.id }`);
  
        // Upload the file
        await uploadBytes(storageRef, file);
  
        // Get the download URL
        const imageUrl = await getDownloadURL(storageRef);
  
        // Update Firestore with the new image URL in users collection
        await updateDoc(doc(db, `users/${selectedMember.id}`), {
          profileImageUrl: imageUrl,
        });
  
        // Also update the profileImageUrl in the profiles collection (query by userId)
        const profilesRef = collection(db, "profiles");
        const profileQuery = query(profilesRef, where("userId", "==", selectedMember.id));
        const profileSnapshot = await getDocs(profileQuery);
        if (!profileSnapshot.empty) {
          const profileDoc = profileSnapshot.docs[0];
          const profileRef = doc(db, "profiles", profileDoc.id);
           await updateDoc(profileRef, {
                    profileImageUrl: imageUrl,
                  });
        
        }
  
  
  
  
      
  
        // Log activity
        if (user) {
          dispatch(
            logActivity({
              userId: selectedMember.id,
              type: "Profile Image Update",
              metadata: { details: "Profile image updated by Owner" },
            })
          );
        }
      } catch (error) {
        console.error("Failed to upload profile image:", error);
      } finally {
        setUploadingImage(false);
      }
    }

  const handleClose = () => {
    setSetUpTeamModel(false);
    setViewEditeModel(false);
    setEditedMemberId(null); // Reset edited member ID
    setViewedMemberId(null); // Reset viewed member ID
    setViewedActivityId(null); // Reset viewed activity ID
  };
  const handleSearch = (value: string) => {
    setSearchTerm(value);
    setCurrentPage(1); // Reset to first page when searching
  };

  // Handle filter application
  const handleApplyFilters = (filters: any) => {
    setFilterCriteria(filters);
    setFilterViewModel(false);
  };

  // Function to handle tab change and reset filters
  const handleTabChange = (tab: string) => {
    setActiveTab(tab);

    // Reset all filters when changing tabs
    setSearchTerm("");
    setActivitySearchTerm("");
    setFilterCriteria({
      status: "",
      role: "",
      walletRange: [],
      amountRange: [],
      customWalletMin: "",
      customWalletMax: "",
      customAmountMin: "",
      customAmountMax: "",
      rating: "",
    });
    setCustomWallet(false);
    setCustomAmount(false);
    setCurrentPage(1);
    setActivityCurrentPage(1);

    // Reset all highlighting when changing tabs
    setViewedMemberId(null);
    setEditedMemberId(null);
    setViewedActivityId(null);
  };

  // Utility function to convert string to dd/mm/yyyy
  function formatDateToDDMMYYYY(dateString) {
    if (!dateString) return "";
    // Parse with Date constructor
    const date = new Date(dateString);
    if (isNaN(date)) return dateString; // fallback if parsing fails

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  }
  // Apply filters to members
  const getFilteredMembers = () => {
    if (!filteredMembers) return [];

    let filtered = [...filteredMembers];

    // Apply search filter first
    if (searchTerm && searchTerm.trim() !== "") {
      const lowerSearchTerm = searchTerm.toLowerCase();
      filtered = filtered.filter(
        (member) =>
          member.name?.toLowerCase().includes(lowerSearchTerm) ||
          member.email?.toLowerCase().includes(lowerSearchTerm) ||
          member.profileData?.teamRole?.toLowerCase().includes(lowerSearchTerm)
      );
    }

    // Apply status filter
    if (filterCriteria.status && filterCriteria.status.trim() !== "") {
      filtered = filtered.filter((member) => {
        // Use the same status logic as displayed in the table
        const actualStatus = member.userData?.disabled === true
          ? "deactivated"
          : member.userData?.disabled === false
          ? "active"
          : member.status;
        
        return actualStatus === filterCriteria.status;
      });
    }

    // Apply role filter
    if (filterCriteria.role && filterCriteria.role.trim() !== "") {
      filtered = filtered.filter(
        (member) => member.profileData?.teamRole === filterCriteria.role
      );
    }

    // Directory tab: Earnings filter for Expert
    if (activeTab === "Directory" && user?.role === "Expert") {
      // Filter by amountRange (Earnings)
      if (filterCriteria.amountRange && filterCriteria.amountRange.length > 0) {
        filtered = filtered.filter((member) => {
          const earningsAmount =
            parseFloat((member.earnings || "").replace("$", "") || "0") || 0;
          return filterCriteria.amountRange.some((range) => {
            switch (range) {
              case "0-100":
                return earningsAmount >= 0 && earningsAmount <= 100;
              case "101-200":
                return earningsAmount >= 101 && earningsAmount <= 200;
              case "201-300":
                return earningsAmount >= 201 && earningsAmount <= 300;
              case "301-400":
                return earningsAmount >= 301 && earningsAmount <= 400;
              case "401-500":
                return earningsAmount >= 401 && earningsAmount <= 500;
              case "501+":
                return earningsAmount > 500;
              default:
                return true;
            }
          });
        });
      }
      // Filter by customAmountMin/customAmountMax (Earnings)
      if (filterCriteria.customAmountMin || filterCriteria.customAmountMax) {
        filtered = filtered.filter((member) => {
          const earningsAmount =
            parseFloat((member.earnings || "").replace("$", "") || "0") || 0;
          const min = parseFloat(filterCriteria.customAmountMin) || 0;
          const max = parseFloat(filterCriteria.customAmountMax) || Infinity;
          return earningsAmount >= min && earningsAmount <= max;
        });
      }
    } else {
      // Default: Wallet filter (for Customer) or legacy logic
      if (filterCriteria.walletRange && filterCriteria.walletRange.length > 0) {
        filtered = filtered.filter((member) => {
          const earningsAmount =
            parseFloat(
              member.earnings?.replace("$", "") ||
                member.wallet?.replace("$", "") ||
                "0"
            ) || 0;
          return filterCriteria.walletRange.some((range) => {
            switch (range) {
              case "0-100":
                return earningsAmount >= 0 && earningsAmount <= 100;
              case "101-200":
                return earningsAmount >= 101 && earningsAmount <= 200;
              case "201-300":
                return earningsAmount >= 201 && earningsAmount <= 300;
              case "301-400":
                return earningsAmount >= 301 && earningsAmount <= 400;
              case "401-500":
                return earningsAmount >= 401 && earningsAmount <= 500;
              case "501+":
                return earningsAmount > 500;
              default:
                return true;
            }
          });
        });
      }
      if (filterCriteria.customWalletMin || filterCriteria.customWalletMax) {
        filtered = filtered.filter((member) => {
          const earningsAmount =
            parseFloat(
              member.earnings?.replace("$", "") ||
                member.wallet?.replace("$", "") ||
                "0"
            ) || 0;
          const min = parseFloat(filterCriteria.customWalletMin) || 0;
          const max = parseFloat(filterCriteria.customWalletMax) || Infinity;
          return earningsAmount >= min && earningsAmount <= max;
        });
      }
    }
    // Sort by createdAt (default: descending; override with filterCriteria.sortOrder)
    filtered.sort(
      (a, b) => getTimestamp(b.createdAt) - getTimestamp(a.createdAt)
    );
    return filtered;
  };

  // Filter activities based on search term
  const getFilteredActivities = () => {
    if (!teamActivities) return [];

    let filtered = [...teamActivities];

    // Apply search filter
    if (activitySearchTerm && activitySearchTerm.trim() !== "") {
      const lowerSearchTerm = activitySearchTerm.toLowerCase();
      filtered = filtered.filter(
        (activity) =>
          activity.expertData?.name?.toLowerCase().includes(lowerSearchTerm) ||
          activity.customerData?.name
            ?.toLowerCase()
            .includes(lowerSearchTerm) ||
          activity.expertData?.email?.toLowerCase().includes(lowerSearchTerm) ||
          activity.customerData?.email
            ?.toLowerCase()
            .includes(lowerSearchTerm) ||
          activity.status?.toLowerCase().includes(lowerSearchTerm) ||
          activity.expertData?.teamRole?.toLowerCase().includes(lowerSearchTerm)
      );
    }

    // Apply status filter
    if (filterCriteria.status && filterCriteria.status.trim() !== "") {
      filtered = filtered.filter((activity) => {
        if (filterCriteria.status === "completed") {
          return activity.status === "completed";
        } else if (filterCriteria.status === "active") {
          return activity.status === "active";
        } else if (filterCriteria.status === "issue-reported") {
          return activity.hasIssue === true;
        }
        return true;
      });
    }

    // Apply amount range filter for activities
    if (filterCriteria.amountRange && filterCriteria.amountRange.length > 0) {
      filtered = filtered.filter((activity) => {
        const activityAmount =
          parseFloat(activity.cost) ||
          parseFloat(activity.totalAmount) ||
          parseFloat(activity.earnings?.replace("$", "")) ||
          0;
        return filterCriteria.amountRange.some((range) => {
          switch (range) {
            case "0-100":
              return activityAmount >= 0 && activityAmount <= 100;
            case "101-200":
              return activityAmount >= 101 && activityAmount <= 200;
            case "201-300":
              return activityAmount >= 201 && activityAmount <= 300;
            case "301-400":
              return activityAmount >= 301 && activityAmount <= 400;
            case "401-500":
              return activityAmount >= 401 && activityAmount <= 500;
            case "501+":
              return activityAmount > 500;
            default:
              return true;
          }
        });
      });
    }

    // Apply custom amount range filter for activities
    if (filterCriteria.customAmountMin || filterCriteria.customAmountMax) {
      filtered = filtered.filter((activity) => {
        const activityAmount =
          parseFloat(activity.cost) ||
          parseFloat(activity.totalAmount) ||
          parseFloat(activity.earnings?.replace("$", "")) ||
          0;
        const min = parseFloat(filterCriteria.customAmountMin) || 0;
        const max = parseFloat(filterCriteria.customAmountMax) || Infinity;
        return activityAmount >= min && activityAmount <= max;
      });
    }

    // Apply rating filter
    if (filterCriteria.rating && filterCriteria.rating.trim() !== "") {
      const targetRating = parseInt(filterCriteria.rating);
      filtered = filtered.filter((activity) => {
        const activityRating = Math.floor(
          activity.customerRating || activity.rating || 0
        );
        return activityRating === targetRating;
      });
    }

    return filtered;
  };

  const Loading = () => (
    <div className="flex flex-col justify-center items-center">
      <Loader className="animate-spin text-[#F15D18] mb-3" size={32} />
      <p className="text-gray-500 text-lg nunito-medium">Loading Team...</p>
    </div>
  );

  const getStatusLabel = (status: string) => {
    switch (status) {
      case "invite-sent":
      case "invited-send":
        return "Invite sent";
      case "invited": // Added this case as mentioned in your request
        return "Invite sent";
      case "deactivated":
        return "Deactivated";
      case "active":
        return "Active";
      default:
        return status || "";
    }
  };

  // Get status color
  const getStatusColor = (status: string) => {
    switch (status) {
      case "invite-sent":
      case "invited send":
        return "bg-[#FFE500] border-[15px] border-yellow-50";

      case "deactivated":
        return "bg-[#D5332A] border-[15px] border-red-50";
      case "active":
        return "bg-[#2E9D2A] border-[15px] border-green-50";
      default:
        return "bg-[#FFE500] border-[15px] border-yellow-50";
    }
  };

  // Update user account status using disableUser or enableUser Firebase Function
  const updateUserAccountStatus = async (uid: string, disabled: boolean) => {
    try {
      const endpoint = disabled
        ? `https://us-central1-supporty-staging.cloudfunctions.net/disableUser/${uid}`
        : `https://us-central1-supporty-staging.cloudfunctions.net/enableUser/${uid}`;
      const response = await fetch(endpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error("Failed to update user status");
      }

      // Store the account status in the user collection
      const userDocRef = doc(db, `users/${uid}`);
      await updateDoc(userDocRef, {
        disabled: disabled,
        updatedAt: new Date().toISOString(),
        updatedBy: user?.email || "owner",
      });

      return await response.json();
    } catch (error) {
      console.error("Error updating user account status:", error);
      throw error;
    }
  };

  const handleAccountStatusToggle = async (
    id: string,
    currentDisabled: boolean
  ) => {
    if (!id) return;
    setStatusLoading(true);
    try {
      const newDisabled = !currentDisabled;

      // Call Firebase function to disable/enable user account
      await updateUserAccountStatus(id, newDisabled);

      // Update selectedMember if it's the same user being updated
      if (
        selectedMember &&
        (selectedMember.id === id || selectedMember.uid === id)
      ) {
        setSelectedMember({
          ...selectedMember,
          userData: {
            ...selectedMember.userData,
            disabled: newDisabled,
          },
          status: newDisabled ? "deactivated" : "active",
        });
      }

      // Update Redux store members immediately
      const updatedMembers = members.map((member) =>
        member.id === id || member.uid === id
          ? {
              ...member,
              userData: {
                ...member.userData,
                disabled: newDisabled,
              },
              status: newDisabled ? "deactivated" : "active",
            }
          : member
      );

      // Dispatch updated members to Redux store
      dispatch(setEnhancedMembers(updatedMembers));

      // Update filtered members to reflect changes immediately
      dispatch(
        filterMembersTeams({
          searchTerm,
          userRole: user.teamRole,
          userId: user.teamId,
        })
      );
    } catch (error) {
      console.error("Failed to update account status", error);
    } finally {
      setStatusLoading(false);
    }
  };
  const StatusIndicator = ({ status }: { status: string }) => (
    <div className="relative group">
      <div className={`${getStatusColor(status)} h-10 w-10 rounded-full`}></div>
      <div className="absolute left-4 -top-4 hidden group-hover:block bg-[#FAFAFA] text-[#696969]  shadow-lg text-xs py-1 px-2 rounded-lg whitespace-nowrap">
        {getStatusLabel(status)}
      </div>
    </div>
  );
  const handleViewMember = (member: any) => {
    setViewedMemberId(member.id || member.uid);
    setSelectedMember(member);
    // Initialize viewData with the member's specialties
    setViewData({
      specialities: member?.profileData?.specialities || [],
    });
    setIsModalOpen(true);
    // Fetch ratings for expert
    dispatch(fetchUserRatingAndReviews({ userId: member.id, role: "Expert" }));
  };
  const ActivityTable = () => {
    // Get filtered activities first
    const filteredActivities = getFilteredActivities();

    // Calculate pagination for activities
    const activityStartIndex = (activityCurrentPage - 1) * itemsPerPage;
    const activityEndIndex = activityStartIndex + itemsPerPage;
    const paginatedActivities =
      filteredActivities?.slice(activityStartIndex, activityEndIndex) || [];
    const totalActivityPages = Math.ceil(
      (filteredActivities?.length || 0) / itemsPerPage
    );

    return (
      <div className="bg-white rounded-[12px] border-[1px] border-[#EBEBEB] overflow-hidden">
        <table className="min-w-full divide-y max-h-[700px] divide-gray-200 ">
          <thead className="bg-[#FEF0EA]">
            <tr>
              <th className="px-3 py-3 text-[14px] nunito-semibold text-[#404040]  tracking-wider">
                Status
              </th>
              <th className="px-3 py-3 text-left   tracking-wider">
                <div className="flex items-center  text-[14px] nunito-semibold text-[#404040] justify-between">
                  Expert Name
                </div>
              </th>
              <th className="px-3 py-3 text-left text-xs font-medium text-[#404040]  tracking-wider">
                <div className="flex items-center  text-[14px] nunito-semibold text-[#404040] justify-between">
                  Customer Name{" "}
                </div>
              </th>
              <th className="px-3 py-3 text-left text-[14px]  nunito-semibold text-[#404040]  tracking-wider">
                Expert Role
              </th>
              <th className="px-3 py-3 text-left text-[14px] nunito-semibold text-[#404040]  tracking-wider">
                Start Time
              </th>
              <th className="px-3 py-3 text-left text-[14px] nunito-semibold text-[#404040]  tracking-wider">
                Duration
              </th>
              <th className="px-3 py-3 text-left text-[14px] nunito-semibold text-[#404040]   tracking-wider">
                Rating
              </th>
              <th className="px-3 py-3 text-left text-[14px] nunito-semibold text-[#404040]  tracking-wider">
                Earnings
              </th>
              <th className="px-3 py-3 text-left text-[14px] nunito-semibold text-[#404040]  tracking-wider">
                Action
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {activitiesLoading ? (
              <tr>
                <td colSpan={9} className="text-center py-10">
                  <div className="flex justify-center">
                    <Loading />
                  </div>
                </td>
              </tr>
            ) : activitiesError ? (
              <tr>
                <td colSpan={9} className="text-center py-10">
                  <div className="text-red-500">
                    Error loading activities: {activitiesError}
                  </div>
                </td>
              </tr>
            ) : paginatedActivities && paginatedActivities.length > 0 ? (
              paginatedActivities.map((activity) => (
                <tr
                  key={activity.id}
                  className={
                    shouldHighlightActivityRow(activity)
                      ? "bg-gray-100"
                      : "bg-white"
                  }
                >
                  <td className="px-3  py-3 flex items-center justify-center">
                    <div
                      className={`w-10 h-10 rounded-full ${
                        activity.status === "completed"
                          ? "bg-[#2E9D2A14]"
                          : activity.status === "active"
                          ? "bg-[#0000FF14]"
                          : activity.hasIssue
                          ? "bg-[#D5332A14]"
                          : "bg-[#2E9D2A14]"
                      } flex items-center justify-center relative group`}
                    >
                      <div
                        className={`w-3 h-3 rounded-full ${
                          activity.status === "completed"
                            ? "bg-[#2E9D2A]"
                            : activity.status === "active"
                            ? "bg-[#0000FF]"
                            : activity.hasIssue
                            ? "bg-[#D5332A]"
                            : "bg-[#2E9D2A]"
                        }`}
                      ></div>
                      <div className="absolute left-4 -top-4 hidden group-hover:block bg-[#FAFAFA] text-[#696969] shadow-lg text-xs py-1 px-2 rounded-lg whitespace-nowrap">
                        {activity.status === "completed"
                          ? "Completed"
                          : activity.status === "active"
                          ? "Active"
                          : activity.hasIssue
                          ? "Issue Reported"
                          : "Completed"}
                      </div>
                    </div>
                  </td>
                  <td className="px-3 py-3">
                    <div className="flex items-center gap-2">
                      {activity.expertData?.profileImageUrl ? (
                        <img
                          className="h-[38px] w-[38px] rounded-full object-cover"
                          src={activity.expertData.profileImageUrl}
                          alt={activity.expertData?.name}
                        />
                      ) : (
                        <div className="w-[38px] h-[38px] rounded-full bg-orange-500 flex items-center justify-center text-white text-sm">
                          {activity.expertData?.name
                            ? activity.expertData.name
                                .split(" ")
                                .map((n: string) => n[0])
                                .join("")
                                .toUpperCase()
                            : "E"}
                        </div>
                      )}
                      <span className=" text-[14px] nunito-semibold truncate max-w-32 text-[#696969]">
                        {activity.expertData?.name || ""}
                      </span>
                    </div>
                  </td>
                  <td className="px-3 py-3">
                    <div className="flex items-center gap-2">
                      {activity.customerData?.profileImageUrl ? (
                        <img
                          className="h-[38px] w-[38px] rounded-full object-cover"
                          src={activity.customerData.profileImageUrl}
                          alt={activity.customerData?.name}
                        />
                      ) : (
                        <div className="h-[38px] w-[38px] rounded-full bg-gray-800 flex items-center justify-center text-white text-sm">
                          {activity.customerData?.name
                            ? activity.customerData.name
                                .split(" ")
                                .map((n: string) => n[0])
                                .join("")
                                .toUpperCase()
                            : "C"}
                        </div>
                      )}
                      <span className="text-[14px] nunito-semibold truncate max-w-32 text-[#696969]">
                        {activity.customerData?.name || ""}
                      </span>
                    </div>
                  </td>{" "}
                  <td className="px-3 py-3 text-[14px] nunito-regular text-[#696969]">
                    {formatRole(
                      activity.expertData?.teamRole || activity.expertData?.role
                    )}
                  </td>
                  <td className="px-3 py-3 text-[14px] nunito-regular text-[#696969]">
                    {activity.startTime?.seconds
                      ? new Date(
                          activity.startTime.seconds * 1000
                        ).toLocaleDateString("en-US", {
                          month: "2-digit",
                          day: "2-digit",
                          year: "numeric",
                        })
                      : activity.createdAt?.seconds
                      ? new Date(
                          activity.createdAt.seconds * 1000
                        ).toLocaleDateString("en-US", {
                          month: "2-digit",
                          day: "2-digit",
                          year: "numeric",
                        })
                      : "N/A"}
                  </td>
                  <td className="px-3 py-3 text-[14px] nunito-regular text-[#696969]">
                    {(() => {
                      const duration = activity.duration;
                      if (!duration) return "- mins";

                      if (
                        typeof duration === "object" &&
                        duration.hours !== undefined
                      ) {
                        const {
                          hours = 0,
                          minutes = 0,
                          seconds = 0,
                        } = duration;
                        if (hours > 0) {
                          return `${hours}h ${minutes}m`;
                        } else if (minutes > 0) {
                          return `${minutes}m ${seconds}s`;
                        } else {
                          return `${seconds}s`;
                        }
                      }

                      if (typeof duration === "number") {
                        return `${duration} mins`;
                      }

                      if (typeof duration === "string") {
                        return duration.includes("min")
                          ? duration
                          : `${duration} mins`;
                      }

                      return "- mins";
                    })()}
                  </td>
                  <td className="px-3 py-3">
                    <div className="flex items-center  space-x-1">
                      <span className="text-[#696969] text-[14px] nunito-regular">
                        {activity.customerRating || 0}
                      </span>
                      <svg
                        className="w-[24px] h-[24px] text-[#F5A038] fill-[#F5A038]"
                        viewBox="0 0 24 24"
                      >
                        <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                      </svg>
                    </div>
                  </td>
                  <td className="px-3 py-3 text-[14px] nunito-regular text-[#696969]">
 ${Number(activity.cost ?? 0).toFixed(2)}{" "}
                    {activity.hasRefund === true && (
                      <span className="text-[#F15D18] ">*</span>
                    )}
                  </td>
                  <td className="pl-3 py-3 ">
                    <div className="flex space-x-5">
                      <button
                        className="text-[#F15D18] hover:text-[#F15A29] underline"
                        onClick={() => handleActivityView(activity)}
                      >
                        View
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={9} className="text-center py-10">
                  {hasActiveFilters() &&
                  teamActivities &&
                  teamActivities.length > 0 ? (
                    <div className="flex flex-col items-center py-20">
                      <div className="w-24 h-24 mb-4 flex items-center justify-center">
                        <Search className="w-16 h-16 text-gray-400" />
                      </div>
                      <h2 className="text-[24px] nunito-semibold text-[#404040] mb-2">
                        Opps! No matching records found.
                      </h2>
                      <p className="text-[#919191] text-[14px] nunito-semibold mb-4 text-center">
                        Try changing the filters or search criteria to see more
                        results!
                      </p>
                    </div>
                  ) : (
                    <div className="flex flex-col items-center">
                      <img
                        src={noActivityImg}
                        className="w-[201px] h-[196px]"
                      />
                      <div className="text-[#696969] text-[16px] nunito-regular mt-4">
                        No activity yet. Encourage your team to start
                        interacting - all their actions will appear here for you
                        to track.
                      </div>
                    </div>
                  )}
                </td>
              </tr>
            )}
          </tbody>
        </table>

        {/* Pagination */}
        {totalActivityPages > 1 && (
          <div className="py-3 flex items-center justify-center">
            <nav className="flex space-x-1">
              {[...Array(totalActivityPages)].map((_, index) => (
                <button
                  key={index + 1}
                  onClick={() => handleActivityPageChange(index + 1)}
                  className={`px-2 py-1 text-[#696969] ${
                    activityCurrentPage === index + 1
                      ? "bg-[#FAFAFA] border-[#EBEBEB] rounded-[8px] border"
                      : ""
                  }`}
                >
                  {String(index + 1).padStart(2, "0")}
                </button>
              ))}
            </nav>
          </div>
        )}
      </div>
    );
  };

  console.log(filteredMembers, "filteredMembers");

  const fetchData = async () => {
    if (!user?.orgId || !user?.uid) {
      setError("No organization ID or user ID found.");
      return;
    }

    setLoading(true);
    setError(null);

    try {
      // Dispatch the fetchAllTeamData action from the team slice
      await dispatch(
        fetchAllTeamData({
          orgId: user.orgId,
          userId: user.teamId,
          currentId: user?.uid,
          userRole: user.uiRole || user?.teamRole,
        })
      ).unwrap();

      if (members && members.length > 0) {
        const enhancedMembers = await Promise.all(
          members.map(async (member) => {
         
            return member;
          })
        );

        // Update the members in the store
        dispatch(setEnhancedMembers(enhancedMembers));
      }
    } catch (err) {
      console.error("Error fetching data:", err);
      setError("Failed to load team data. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  // Enhanced useEffect to fetch team data including rates and earnings
  useEffect(() => {
    fetchData();
  }, [dispatch, user?.orgId, user?.uid, user?.uiRole]);

  // Real-time listeners are now managed in App.tsx for background updates
  // Only apply filters when search term changes
  useEffect(() => {
    if (user?.uid && user?.orgId && user?.teamId && members.length > 0) {
      console.log('Applying search filter:', { searchTerm, teamId: user.teamId, userRole: user.uiRole });
      dispatch(
        filterMembersTeams({
          searchTerm,
          userRole: user.uiRole,
          userId: user.teamId, // Use teamId for proper team filtering
        })
      );
    }
  }, [dispatch, searchTerm, user?.uid, user?.orgId, user?.teamId, user?.uiRole, members.length]);

  // Setup specific current team listener for real-time team updates
  useEffect(() => {
    if (user?.orgId && user?.teamId) {
      dispatch(
        setupCurrentTeamListener({
          orgId: user.orgId,
          userId: user.teamId,
        })
      );
    }

    // Cleanup current team listener when dependencies change
    return () => {
      dispatch(cleanupCurrentTeamListener());
    };
  }, [dispatch, user?.orgId, user?.teamId]);

  // Log current team updates for debugging
  useEffect(() => {
    if (currentTeam) {
      console.log("Current team updated in real-time:", {
        id: currentTeam.id,
        teamName: currentTeam.teamName,
        users: currentTeam.users?.length || 0,
        updatedAt: currentTeam.updatedAt,
      });
    }
  }, [currentTeam]);

  // Fetch team activities when tab is Activity and team data is loaded
  useEffect(() => {
    if (
      activeTab === "Activity" &&
      user?.uid &&
      user?.orgId &&
      (user?.uiRole || user?.teamRole) &&
      currentTeam &&
      status === "succeeded"
    ) {
      console.log("Fetching team activities with params:", {
        userRole: user.uiRole || user.teamRole,
        orgId: user.orgId,
        userId: user.uid,
        currentTeam: currentTeam,
      });

      dispatch(
        fetchTeamActivities({
          userRole: user.uiRole || user.teamRole,
          orgId: user.orgId,
          userId: user.teamId,
          currentTeam: currentTeam,
        })
      );
    }
  }, [dispatch, activeTab, user, currentTeam, status]);
  // Function to fetch additional user data (rate/min and earnings)
  

  // Fetch ratings for all team members when members data is loaded
  useEffect(() => {
    if (members && members.length > 0) {
      members.forEach((member) => {
        if (member.id || member.uid) {
          dispatch(
            fetchUserRatingAndReviews({
              userId: member.id || member.uid,
              role: "Customer",
            })
          );
        }
      });
    }
  }, [dispatch, members]);

  // Fetch ratings for all activity participants when activities are loaded
  useEffect(() => {
    if (teamActivities && teamActivities.length > 0) {
      teamActivities.forEach((activity) => {
        // Fetch expert ratings
        if (activity.expertId || activity.expertData?.id) {
          dispatch(
            fetchUserRatingAndReviews({
              userId: activity.expertId || activity.expertData.id,
              role: "Expert",
            })
          );
        }
        // Fetch customer ratings
        if (activity.customerId || activity.customerData?.id) {
          dispatch(
            fetchUserRatingAndReviews({
              userId: activity.customerId || activity.customerData.id,
              role: "Customer",
            })
          );
        }
      });
    }
  }, [dispatch, teamActivities]);

  return (
    <Layout>
      <div
        className="p-6 bg-white rounded-lg shadow"
        style={{
          height: "calc(100vh - 112px)",
          overflowY: "auto",
            overflowX:'hidden'
        }}
      >
        {/* Tabs */}
        <div className=" mb-1">
          <div className="flex">
            {" "}
            <button
              className={`py-2 px-8 text-[16px] nunito-semibold ${
                activeTab === "Directory"
                  ? "border-b-[4px] border-[#F15D18] text-[#F15D18]"
                  : "text-[#A8A8A8]"
              }`}
              onClick={() => handleTabChange("Directory")}
            >
              Directory
            </button>
            <button
              className={`py-2 px-8 text-[16px] nunito-semibold ${
                activeTab === "Activity"
                  ? "border-b-[4px] border-[#F15D18] text-[#F15D18]"
                  : "text-[#A8A8A8]"
              }`}
              onClick={() => handleTabChange("Activity")}
            >
              Team Activity
            </button>
          </div>
        </div>

        {/* Header */}
        <div className="flex justify-between items-center mb-2">
          <h2 className="text-[20px] nunito-semibold text-[#696969]">
            {activeTab}
          </h2>
          <div className=" relative flex items-center">
            {activeTab === "Directory" &&
              user?.uiRole !== "expert_team_member" &&
              filteredMembers.length > 0 && (
                <button
                  className="bg-[#F15D18] w-[149px] h-[40px] text-white text-[14px] nunito-bold  px-4 rounded-[8px] flex items-center mr-6"
                  onClick={() => setAddMember(true)}
                >
                  <span className="mr-1">
                    <Plus className="w-[24px] h-[24px]" />
                  </span>{" "}
                  Add Member
                </button>
              )}{" "}
            <div className="relative">
              <input
                type="text"
                placeholder="Search"
                className="w-[215px] h-[40px] pl-11 pr-5 py-2 text-[#919191] text-[16px] nunito-regular border-[1.4px] border-[#EBEBEB] rounded-[8px]"
                value={
                  activeTab === "Directory" ? searchTerm : activitySearchTerm
                }
                onChange={(e) => {
                  if (activeTab === "Directory") {
                    handleSearch(e.target.value);
                  } else {
                    setActivitySearchTerm(e.target.value);
                  }
                }}
              />
              <Search className=" absolute left-2 flex items-center  top-2 h-[24px] w-[24px] text-[#919191]" />
            </div>
            <div className=" relative">
              <button
                className={`ml-4 p-2 w-[40px] h-[40px] border-[1.4px] border-[#EBEBEB] rounded-[8px] ${
                  hasActiveFilters()
                    ? "bg-[#F15D18]"
                    : filterViewModel
                    ? "bg-[#EBEBEB]"
                    : ""
                }`}
                onClick={() => setFilterViewModel(!filterViewModel)}
              >
                <Filter
                  className={`h-[24px] w-[24px] ${
                    hasActiveFilters() ? "text-white" : "text-[#919191]"
                  }`}
                />
              </button>{" "}
            </div>
            <div className="relative group">

            <button className="ml-2 p-2 w-[40px] h-[40px] border-[1.4px] border-[#EBEBEB] rounded-[8px]">
              <Download className="h-[24px] w-[24px] text-[#919191]" />
            </button>        <div className="absolute right-0 -top-8 px-2 py-1 bg-[#FAFAFA] nunito-regular text-[12px] text-[#696969] text-xs rounded-[8px] shadow-lg opacity-0 group-hover:opacity-100 pointer-events-none transition-opacity duration-200 whitespace-nowrap z-30" dir="rtl">
             !This feature is on its way - stay tuned
            </div>
          </div>
            {filterViewModel && (
              <FilterModelTeam
                sections={sections}
                setSections={setSections}
                customWallet={customWallet}
                setCustomWallet={setCustomWallet}
                customAmount={customAmount}
                setCustomAmount={setCustomAmount}
                setFilterViewModel={setFilterViewModel}
                onApplyFilters={handleApplyFilters}
                activeTab={activeTab}
                appliedFilters={filterCriteria}
              />
            )}
          </div>
        </div>
        {user?.teamRole === "expert_team_member" ? (
          <>
            {" "}
            <div className="flex flex-col items-center justify-center w-[608px]   mx-auto text-center">
              {/* Orange squares with circles */}
              <img src={teamRoleMemberimg} className="w-[324px] h-[279px]" />

              {/* Text */}
              <h2 className="text-[24px] nunito-semibold text-[#404040] mt-1 mb-6">
                Upgrade your plan to enjoy the benefits of adding and working
                with your team!
              </h2>

              {/* Button */}
              <button className="w-[93px] h-[40px] bg-[#F15D18]  px-2 py-2 rounded-[8px] text-[14px] text-[#FFFFFF] nunito-bold">
                Upgrade
              </button>
            </div>
          </>
        ) : (
          <>
            {" "}
            {/* Content area */}
            {activeTab === "Directory" ? (
              <>
                <div className=" rounded-[12px] border-[1px] border-[#EBEBEB] overflow-hidden">
                  <table className="min-w-full divide-y max-h-[751px] divide-gray-200 ">
                    <thead className="bg-[#FEF0EA]">
                      <tr>
                        <th className="px-3  py-3  text-[14px]  nunito-semibold text-[#404040]  tracking-wider">
                          Status
                        </th>
                        <th className="px-3 py-3 text-left  text-[14px] nunito-semibold text-[#404040]  tracking-wider">
                          Name
                        </th>
                        <th className="px-3 py-3 text-left text-[14px] nunito-semibold text-[#404040]  tracking-wider">
                          Role
                        </th>
                        <th className="px-3 py-3 text-left text-[14px] nunito-semibold text-[#404040]  tracking-wider">
                          Email
                        </th>
                        <th className="px-3 py-3 text-left text-[14px] nunito-semibold text-[#404040]  tracking-wider">
                          Rate/min
                        </th>
                        <th className="px-3 py-3 text-left text-[14px] nunito-semibold text-[#404040]  tracking-wider">
                          Total Sessions
                        </th>
                        <th className="px-3 py-3 text-left text-[14px] nunito-semibold text-[#404040]  tracking-wider">
                          Last Activity
                        </th>
                        <th className="px-3 py-3 text-left  text-[14px] nunito-semibold text-[#404040]  tracking-wider">
                          Total Earnings
                        </th>
                        <th className="px-3 py-3 text-left text-[14px] nunito-semibold text-[#404040]  tracking-wider">
                          Action
                        </th>
                      </tr>
                    </thead>{" "}
                    <tbody className="bg-white divide-y divide-gray-200">
                      {" "}
                      {loading || filteredMembersLoading ? (
                        <tr>
                          <td colSpan={9} className="text-center py-10">
                            <div className="flex justify-center items-center flex-col gap-2">
                              <Loading />
                              <p className="text-sm text-gray-500">
                                {loading ? 'Loading team data...' : 'Filtering members...'}
                              </p>
                            </div>
                          </td>
                        </tr>
                      ) : (
                        (() => {
                          // Get filtered members based on applied filters
                          const membersToShow = getFilteredMembers();

                          // Pagination calculations for directory
                          const startIndex = (currentPage - 1) * itemsPerPage;
                          const endIndex = startIndex + itemsPerPage;
                          const paginatedFilteredMembers =
                            membersToShow?.slice(startIndex, endIndex) || [];

                          return paginatedFilteredMembers?.length > 0 ? (
                            paginatedFilteredMembers?.map((member) => (
                              <tr
                                key={member.id}
                                className={
                                  shouldHighlightRow(member)
                                    ? "bg-gray-100"
                                    : "bg-white"
                                }
                              >
                                <td className="px-3 py-3 whitespace-nowrap">
                                  <div className="flex items-center justify-center">
                                    <StatusIndicator
                                      status={
                                        member.userData?.disabled === true
                                          ? "deactivated"
                                          : member.userData?.disabled === false
                                          ? "active"
                                          : member.status
                                      }
                                    />
                                  </div>
                                </td>
                                <td className="px-3 py-3 whitespace-nowrap">
                                  <div className="flex items-center">
                                    {member.avatar ? (
                                      <img
                                        className="h-[38px] w-[38px] rounded-full"
                                        src={member.avatar}
                                        alt=""
                                      />
                                    ) : (
                                      <div className="h-[38px] w-[38px] rounded-full bg-gray-800 flex items-center justify-center text-white text-sm">
                                        {member.initials}
                                      </div>
                                    )}
                                    <div className="ml-3">
                                      <div className="text-[14px] nunito-semibold text-[#696969]">
                                        {member.name}
                                      </div>
                                    </div>
                                  </div>
                                </td>
                                <td className="px-3 py-3 whitespace-nowrap">
                                  <div className="text-[14px] nunito-regular text-[#696969]">
                                    {formatRole(
                                      member.profileData?.teamRole ||
                                        member?.role
                                    )}
                                  </div>
                                </td>
                                <td className="px-3 py-3 whitespace-normal">
                                  <div className="text-[14px] nunito-regular truncate max-w-44 text-[#696969] flex flex-col">
                                    <span>{member.email.slice(0, 15)}</span>
                                    <span>{member.email.slice(15)}</span>
                                  </div>
                                </td>
                                <td className="px-3 py-3 whitespace-nowrap text-[14px] nunito-regular text-[#696969]">
                               {member.profileData?.ratePerMinute !== undefined && member.profileData?.ratePerMinute !== null && !isNaN(Number(member.profileData?.ratePerMinute))
    ? `$${Number(member.profileData.ratePerMinute).toFixed(2)}`
    : "-"}
                                </td>
                                <td className="px-3 py-3 whitespace-nowrap text-[14px] nunito-regular text-[#696969]">
                                  {member.totalActivity || 0}
                                </td>
                                <td className="px-3 py-3 whitespace-nowrap text-[14px] nunito-regular text-[#696969]">
                                  {formatDateToDDMMYYYY(
                                    member.lastActivityexpert || "No activity"
                                  )}
                                </td>
                                <td className="px-3 py-3 whitespace-nowrap text-[14px] nunito-regular text-[#696969]">
                                  {member.earnings || 0}
                                </td>
                                <td className="px-3 py-3 whitespace-nowrap text-right text-sm font-medium">
                                  <div className="flex space-x-3 justify-end">
                                    {member.status !== "invited" && (
                                      <button
                                        className=""
                                        onClick={() => handleEditMember(member)}
                                      >
                                        <Pencil className="h-[20px] w-[20px] text-[#919191] hover:text-gray-500 stroke-[2px]  " />
                                      </button>
                                    )}
                                    <div className="relative group">

                                    <button
                                      className=""
                                      disabled={member?.status !== "active"}
                                      >
                                      <Trash className="h-[20px] w-[20px] text-[#919191] hover:text-gray-500 stroke-[2px] " />
                                    </button>
                                       <div className="absolute right-0 -top-8 px-2 py-1 bg-[#FAFAFA] nunito-regular text-[12px] text-[#696969] text-xs rounded-[8px] shadow-lg opacity-0 group-hover:opacity-100 pointer-events-none transition-opacity duration-200 whitespace-nowrap z-30" dir="rtl">
            !This feature is on its way - stay tuned
          </div>
                                      </div>
                                    <button
                                      className={`${
                                        member.status === "invited" ||
                                        member.status === "invited-send"
                                          ? "text-gray-400 cursor-not-allowed"
                                          : "text-[#F15D18] underline cursor-pointer"
                                      } text-[14px] nunito-semibold`}
                                      disabled={
                                        member.status === "invited" ||
                                        member.status === "invited-send"
                                      }
                                      onClick={() => handleViewMember(member)}
                                    >
                                      View
                                    </button>
                                  </div>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan={9} className="">
                                {(() => {
                                  // Check if filters are applied
                                  const filtersActive =
                                    hasActiveFilters() ||
                                    searchTerm.trim() !== "";

                                  // If filters/search are applied but no results found
                                  if (
                                    filtersActive &&
                                    members &&
                                    members.length > 0
                                  ) {
                                    return (
                                      <div className="flex flex-col items-center py-20">
                                        <div className="w-24 h-24 mb-4 flex items-center justify-center">
                                          <Search className="w-16 h-16 text-gray-400" />
                                        </div>
                                        <h2 className="text-[24px] nunito-semibold text-[#404040] mb-2">
                                          Opps! No matching records found.
                                        </h2>
                                        <p className="text-[#919191] text-[14px] nunito-semibold mb-4 text-center">
                                          Try changing the filters or search
                                          criteria to see more results!
                                        </p>
                                      </div>
                                    );
                                  }

                                  // If no filters/search and team exists, show team setup complete
                                  if (currentTeam) {
                                    return (
                                      <div className="flex flex-col items-center py-20">
                                        <div className="bg-[#4BB847] border-gray-100 border-[10px] rounded-full p-4 flex items-center justify-center mb-4">
                                          <Check className="text-white w-[40px] h-[40px]" />
                                        </div>
                                        <h2 className="text-[24px] nunito-semibold text-[#404040] mb-2">
                                          Team setup is complete!
                                        </h2>
                                        <p className="text-[#696969] text-[16px] nunito-regular mb-4 text-center">
                                          Your team is ready to roll. Add
                                          members, assign roles, and unlock the
                                          full potential of seamless teamwork.
                                        </p>
                                        <button
                                          className="bg-[#F15D18] w-[149px] h-[40px] text-white text-[14px] nunito-bold px-4 rounded-[8px] flex items-center justify-center"
                                          onClick={() => setAddMember(true)}
                                        >
                                          <span className="mr-1">
                                            <Plus className="w-[20px] h-[20px]" />
                                          </span>
                                          Add Member
                                        </button>
                                      </div>
                                    );
                                  }

                                  return (
                                    <div className="flex flex-col items-center py-11">
                                      <img
                                        src={emtyimg}
                                        alt="Empty State"
                                        className="w-[444px] h-[227px] mb-4"
                                      />

                                      <button
                                        className="bg-[#F15D18] w-[150px] h-[40px] mt-2 rounded-[8px] text-[#FFFFFF] text-[14px] nunito-bold"
                                        onClick={handleSetupTeamClick}
                                      >
                                        Set up your Team
                                      </button>
                                      <p className=" text-[16px] nunito-regular mt-4  text-[#696969]">
                                        Create your team, invite members, and
                                        lead the way - it all starts with you!
                                      </p>
                                    </div>
                                  );
                                })()}
                              </td>
                            </tr>
                          );
                        })()
                      )}
                    </tbody>
                  </table>{" "}
                </div>{" "}
                {/* Pagination for Directory */}
                {(() => {
                  const membersToShow = getFilteredMembers();
                  const totalDirectoryPages = Math.ceil(
                    (membersToShow?.length || 0) / itemsPerPage
                  );

                  return (
                    totalDirectoryPages > 1 && (
                      <div className="py-3 flex items-center justify-center">
                        <nav className="flex space-x-1">
                          {[...Array(totalDirectoryPages)].map((_, index) => (
                            <button
                              key={index + 1}
                              onClick={() => handlePageChange(index + 1)}
                              className={`px-2 py-1 text-[#696969] ${
                                currentPage === index + 1
                                  ? "bg-[#FAFAFA] border-[#EBEBEB] rounded-[8px] border"
                                  : ""
                              }`}
                            >
                              {String(index + 1).padStart(2, "0")}
                            </button>
                          ))}
                        </nav>
                      </div>
                    )
                  );
                })()}
              </>
            ) : (
              <ActivityTable />
            )}
          </>
        )}
      </div>
      {/* directory table model */}
      {/* Modal */}
      {setupTeamModel && (
        <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl shadow-lg w-full max-w-2xl max-h-[90vh] overflow-y-auto p-4 px-6 relative">
            <div className="flex justify-between items-center mb-3 sticky top-0 bg-white pb-3 border-b border-gray-100">
              <h2 className="text-[24px] text-[#0A0A0A] nunito-semibold">
                Setup Team
              </h2>
              <button
                className="text-[#344054] hover:text-gray-700"
                onClick={handleClose}
              >
                <X className="w-[20px] h-[20px]" />
              </button>
            </div>

            <form onSubmit={handleSubmit}>
              <div className="space-y-3 pt-3">
                <div>
                  {" "}
                  <h3 className="text-[16px] text-[#0A0A0A] nunito-semibold mb-4">
                    Organization Details
                  </h3>
                  {loadingOrgData ? (
                    <div className="flex justify-center items-center py-8">
                      <Loader
                        className="animate-spin text-[#F15D18] mr-2"
                        size={20}
                      />
                      <span className="text-[#696969] text-[14px]">
                        Loading organization details...
                      </span>
                    </div>
                  ) : (
                    <>
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                        <div>
                          <label className="block text-[16px] nunito-semibold text-[#404040] mb-1">
                            Organization Name
                          </label>
                          <input
                            type="text"
                            name="orgName"
                            placeholder="Enter Organization Name"
                            value={formData.orgName}
                            onChange={handleChange}
                            required
                            className="w-full px-3 py-2 border border-[#D7DEDD] rounded-[6px] text-[#404040] text-[14px] nunito-normal focus:outline-none focus:ring-2 focus:ring-orange-500"
                          />
                        </div>

                        <div>
                          <label className="block text-[16px] nunito-semibold text-[#404040] mb-1">
                            Organization URL
                          </label>
                          <input
                            type="text"
                            name="orgUrl"
                            placeholder="Enter Organization URL"
                            value={formData.orgUrl}
                            onChange={handleChange}
                            required
                            className="w-full px-3 py-2 border border-[#D7DEDD] rounded-[6px] text-[#404040] text-[14px] nunito-normal focus:outline-none focus:ring-2 focus:ring-orange-500"
                          />
                        </div>
                      </div>

                      <div className="mb-4">
                        <label className="block text-[16px] nunito-semibold text-[#404040] mb-1">
                          Tax ID (Used for Invoicing)
                        </label>
                        <input
                          type="text"
                          name="taxId"
                          placeholder="Enter Tax ID"
                          value={formData.taxId}
                          onChange={handleChange}
                          className="w-full px-3 py-2 border border-[#D7DEDD] rounded-[6px] text-[#404040] text-[14px] nunito-normal focus:outline-none focus:ring-2 focus:ring-orange-500"
                        />
                      </div>

                      <div className="mb-4">
                        <label className="block text-[16px] nunito-semibold text-[#404040] mb-1">
                          Address Line 1
                        </label>
                        <input
                          type="text"
                          name="addressLine1"
                          placeholder="Enter Address Line 1"
                          value={formData.addressLine1}
                          onChange={handleChange}
                          required
                          className="w-full px-3 py-2 border border-[#D7DEDD] rounded-[6px] text-[#404040] text-[14px] nunito-normal focus:outline-none focus:ring-2 focus:ring-orange-500"
                        />
                      </div>

                      <div className="mb-4">
                        <label className="block text-[16px] nunito-semibold text-[#404040] mb-1">
                          Address Line 2
                        </label>
                        <input
                          type="text"
                          name="addressLine2"
                          placeholder="Enter Address Line 2 (Optional)"
                          value={formData.addressLine2}
                          onChange={handleChange}
                          className="w-full px-3 py-2 border border-[#D7DEDD] rounded-[6px] text-[#404040] text-[14px] nunito-normal focus:outline-none focus:ring-2 focus:ring-orange-500"
                        />
                      </div>

                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                        <div>
                          <label className="block text-[16px] nunito-semibold text-[#404040] mb-1">
                            Country
                          </label>
                          <div className="relative">
                            <select
                              name="country"
                              value={formData.country}
                              onChange={handleChange}
                              required
                              className="w-full px-3 py-2 border border-[#D9D9D9] rounded-[8px] text-[#404040] text-[14px] nunito-normal appearance-none focus:outline-none focus:ring-2 focus:ring-orange-500"
                            >
                              <option value="">Select country</option>
                              {Array.isArray(countries) &&
                                countries.map((country) => (
                                  <option
                                    key={country.shortName || country.code}
                                    value={country.shortName || country.code}
                                  >
                                    {country.name}
                                  </option>
                                ))}
                            </select>
                            <div className="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none">
                              <svg
                                className="w-[16px] h-[16px] text-[#696969]"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth="2"
                                  d="M19 9l-7 7-7-7"
                                ></path>
                              </svg>
                            </div>
                          </div>
                        </div>

                        <div>
                          <label className="block text-[16px] nunito-semibold text-[#404040] mb-1">
                            State
                          </label>
                          <div className="relative">
                            <select
                              name="state"
 value={getStateFullName(
                                formData.country || " ",
                                formData.state || " "
                              )}
                              onChange={handleChange}
                              disabled={
                                !formData.country ||
                                !Array.isArray(states) ||
                                states.length === 0
                              }
                              required
                              className="w-full px-3 py-2 border border-[#D9D9D9] rounded-[8px] text-[#404040] text-[14px] nunito-normal appearance-none focus:outline-none focus:ring-2 focus:ring-orange-500 disabled:bg-gray-100 disabled:cursor-not-allowed"
                            >
                              <option value="">
                                {!formData.country
                                  ? "Select country first"
                                  : "Select state"}
                              </option>
                              {Array.isArray(states) &&
                                states.map((state, index) => (
                                  <option key={index} value={state}>
                                    {state}
                                  </option>
                                ))}
                            </select>
                            <div className="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none">
                              <svg
                                className="w-[16px] h-[16px] text-[#696969]"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth="2"
                                  d="M19 9l-7 7-7-7"
                                ></path>
                              </svg>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                        <div>
                          <label className="block text-[16px] nunito-semibold text-[#404040] mb-1">
                            City
                          </label>
                          <input
                            type="text"
                            name="city"
                            placeholder="Enter City"
                            value={formData.city}
                            onChange={handleChange}
                            required
                            className="w-full px-3 py-2 border border-[#D7DEDD] rounded-[6px] text-[#404040] text-[14px] nunito-normal focus:outline-none focus:ring-2 focus:ring-orange-500"
                          />
                        </div>

                        <div>
                          <label className="block text-[16px] nunito-semibold text-[#404040] mb-1">
                            Zip Code
                          </label>
                          <input
                            type="text"
                            name="zipCode"
                            placeholder="Enter Zip Code"
                            value={formData.zipCode}
                            required
                            onChange={handleChange}
                            className="w-full px-3 py-2 border border-[#D7DEDD] rounded-[6px] text-[#404040] text-[14px] nunito-normal focus:outline-none focus:ring-2 focus:ring-orange-500"
                          />
                        </div>
                      </div>
                    </>
                  )}
                </div>
                <div>
                  <h3 className="text-[16px] text-[#0A0A0A] nunito-semibold mb-4">
                    Team Details
                  </h3>

                  <div className="mb-4">
                    <label className="block text-[16px] nunito-semibold text-[#404040] mb-1">
                      Team Name
                    </label>
                    <input
                      type="text"
                      name="teamName"
                      placeholder="Enter Team Name"
                      value={formData.teamName}
                      onChange={handleChange}
                      required
                      className="w-full px-3 py-2 border border-[#D7DEDD] rounded-[6px] text-[#404040] text-[14px] nunito-normal focus:outline-none focus:ring-2 focus:ring-orange-500"
                    />
                  </div>
                </div>{" "}
                <div className="flex justify-center">
                  <button
                    type="submit"
                    disabled={isSubmittingTeam}
                    className={`px-6 py-2 w-[95px] h-[44px] bg-[#F15D18] text-white text-[18px] nunito-semibold rounded-md hover:bg-orange-600 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-offset-2 flex items-center justify-center ${
                      isSubmittingTeam ? "opacity-75 cursor-not-allowed" : ""
                    }`}
                  >
                    {isSubmittingTeam ? (
                      <>
                        <Loader className="animate-spin w-4 h-4 mr-2" />
                        <span className="text-[14px]">Saving...</span>
                      </>
                    ) : (
                      "Submit"
                    )}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      )}{" "}
      {isModalOpen && selectedMember && (
        <div
          className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50"
          onClick={(e) => {
            if (e.target === e.currentTarget) {
              setIsModalOpen(false);
              setSelectedMember(null);
            }
          }}
        >
          <div className="bg-white rounded-[24px] w-[560px] shadow-lg p-4">
            <div className="text-right">
              <button
                onClick={() => {
                  setIsModalOpen(false);
                  setSelectedMember(null);
                  setViewedMemberId(null); // Reset viewed member ID
                }}
                className="text-[#696969] hover:text-gray-700"
              >
                <X className="w-[32px] h-[32px] stroke-[2px]" />
              </button>
            </div>
            <div className="relative border-[1px] border-[#C4C4C4] mb-3 rounded-[16px] p-4">
              <div className="text-[20px] truncate max-w-36 nunito-semibold text-[#0A0A0A] absolute top-4 right-4">
                {orgData?.teamName || ""}
              </div>
              <div className="flex items-center space-x-4 mb-6 relative">
                <div className="relative flex justify-center">
                  {selectedMember?.avatar ? (
                    <img
                      src={selectedMember.avatar}
                      alt="Profile"
                      className="w-[80px] h-[80px] rounded-[16px] object-cover"
                    />
                  ) : (
                    <div className="w-[80px] h-[80px] rounded-[16px] bg-[#F15D18] flex items-center justify-center text-white text-2xl font-bold">
                      {selectedMember?.name
                        ?.split(" ")
                        .map((part) => part.charAt(0).toUpperCase())
                        .join("") || "E"}
                    </div>
                  )}
                  {selectedMember?.status === "deactivated" ? (
                    <span className="bg-[#FFE1E0] text-[#D5332A] px-2 py-1 flex items-center justify-center rounded-[16px] text-[12px] absolute bottom-0 transform translate-y-1/2">
                      Deactivated
                    </span>
                  ) : selectedMember?.status === "invited" ||
                    selectedMember?.userData?.disabled === undefined ? (
                    <span className="bg-[#FFF8CC] text-[#D9A41C] px-2 py-1 flex items-center justify-center rounded-[16px] text-[12px] absolute bottom-0 transform translate-y-1/2">
                      Invite sent
                    </span>
                  ) : selectedMember?.userData?.disabled === true ? (
                    <span className="bg-[#FFE1E0] text-[#D5332A] px-2 py-1 flex items-center justify-center rounded-[16px] text-[12px] absolute bottom-0 transform translate-y-1/2">
                      Deactivated
                    </span>
                  ) : (
                    <span className="bg-[#CBF3C9] text-[#1B8717] px-2 py-1 flex items-center justify-center rounded-[16px] text-[12px] absolute bottom-0 transform translate-y-1/2">
                      Active
                    </span>
                  )}
                </div>
                <div className="flex-1">
                  <div className="group relative inline-block    ">
                    <span className=" text-[#0A0A0A] truncate  text-[24px] nunito-semibold ">

                        {selectedMember?.name?.length > 20
                          ? `${selectedMember.name.slice(0, 20)}...`
                          : selectedMember?.name || ""}
                    </span>
                  
                    {/* Tooltip on hover */}
                    <div className="absolute z-10 opacity-0 group-hover:opacity-100 top- bottom-7  px-2 py-1 bg-[#FAFAFA] text-[#696969] text-xs rounded-[8px] shadow-lg transition-opacity duration-200 pointer-events-none">
                      <div className="text-start">
                        <div className="nunito-regular text-[12px] text-[#696969] mb-1">
                          {selectedMember?.name}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="group relative">

                  <p className="text-[#404040] truncate max-w-96 text-[14px] nunito-medium">
                    {selectedMember?.email || ""}
                  </p>
                     <div className="absolute z-10 opacity-0 group-hover:opacity-100 top- bottom-5  px-2 py-1 bg-[#FAFAFA] text-[#696969] text-xs rounded-[8px] shadow-lg transition-opacity duration-200 pointer-events-none">
                                <div className="text-start">
                                  <div className="nunito-regular text-[12px]  truncate text-[#696969] mb-1">
 {selectedMember?.email || ""}
                                  </div>
                                </div>
                              </div>
                  </div>
                  
                    <span className="text-[#696969] text-[14px] nunito-medium">
                      ({formatRole(selectedMember?.profileData?.teamRole)})
                    </span>

                  <div className="flex items-center justify-between">
                    <div className="flex items-center">
                      <Star className="w-[20px] h-[20px] fill-[#F5A038] text-[#F5A038]" />
                      <span className="text-[#696969] text-[14px] nunito-regular">
                        {ratingsLoading[selectedMember?.id]
                          ? ""
                          : userRatings[selectedMember?.id]?.avgRating?.toFixed(
                              1
                            ) || "0.0"}
                      </span>
                      <span className="text-[#696969] text-[14px] nunito-regular ml-1">
                        (
                        {ratingsLoading[selectedMember?.id]
                          ? "..."
                          : userRatings[selectedMember?.id]?.totalReviews ||
                            "0"}{" "}
                        reviews)
                      </span>
                    </div>
                    <div className="text-[#696969] flex items-center">
                      <Clock className="w-[14px] text-[#696969] h-[14px]" />
                      <span className="text-[14px] text-[#404040] nunito-regular ml-1">
                        {selectedMember?.lastActivityexpert || ""}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="grid grid-cols-3 gap-4 pt-2">
                <div>
                  <p className="text-[#696969] text-[16px] nunito-medium">
                    Total Sessions
                  </p>
                  <p className="nunito-bold text-[#F15D18] text-[20px]">
                    {selectedMember?.totalActivity ||
                      selectedMember?.activities ||
                      "0"}
                  </p>
                </div>
                <div>
                  <p className="text-[#696969] text-[16px] nunito-medium">
                    Rate per min
                  </p>
                  <p className="nunito-bold text-[#F15D18] text-[20px]">
                   ${Number(selectedMember.profileData?.ratePerMinute).toFixed(2) || "0.00"}
                  </p>
                </div>
                <div>
                  <p className="text-[#696969] text-[16px] nunito-medium">
                    Total Earnings
                  </p>
                  <p className="nunito-bold text-[#F15D18] text-[20px]">
                    {selectedMember?.earnings ||
                    
                      "$0.00"}
                  </p>
                </div>
              </div>{" "}
              <div className="mx-3">
                <p className="text-[#696969] text-[16px] nunito-medium mb-2">
                  Specialties
                </p>
                <div className="flex flex-col">
                  <div className="grid grid-cols-2 gap-2 max-h-[200px] overflow-y-auto">
                    {selectedMember?.profileData?.specialities &&
                    selectedMember.profileData.specialities.length > 0 ? (
                      selectedMember.profileData.specialities.map(
                        (specialty: string, index: number) => (
                          <div
                            key={index}
                            className="bg-[#FAFAFA] px-3 py-1 text-[#404040] rounded-[16px] text-[14px] nunito-semibold text-center"
                          >
                            {specialty}
                          </div>
                        )
                      )
                    ) : (
                      <div className="col-span-2 text-gray-500 text-sm italic">
                        No specialties available
                      </div>
                    )}
                  </div>

                  <div className="flex justify-end mt-2">
                    <button
                      className="text-gray-500 flex items-center"
                      onClick={() => {
                        handleEditMember(selectedMember);
                        setIsModalOpen(false);
                      }}
                    >
                      <Pencil className="w-[24px] h-[24px] text-[#696969]" />
                    </button>
                  </div>
                </div>
              </div>
            </div>{" "}
            {/* asana */}
            <div className="flex items-center  p-4  bg-white rounded-[16px]   border-[1px] border-[#C4C4C4] relative">
              {/* Logo/Icon */}
              <div className="mr-2">
                <Building2 className="w-[80px] h-[80px] stroke-[0.5px] text-[#000000]" />
              </div>
              {/* Text Content */}
              <div className="flex-grow">
                <div className="flex justify-between items-start">
                  <h2 className="text-[20px] nunito-semibold text-[#0A0A0A]">
                    {orgData?.name || "Organization"}
                  </h2>
                  <div className="flex items-center text-[#404040] text-[12px]">
                    <NotepadText className="w-[16px] h-[16px] mr-1 text-[#7B7B7B]" />
                    <span>Tax ID: {orgData?.taxId || "N/A"}</span>
                  </div>
                </div>
                <div className="">
                  <p className="text-[14px] nunito-medium text-[#404040] mt-">
                    Website: {orgData?.url || "N/A"}
                  </p>
                  <p className="text-[14px] nunito-medium text-[#404040] mt-">
                    Address:{" "}
                    {orgData?.billingAddress
                      ? `${orgData.billingAddress.address_1 || ""}, ${
                          orgData.billingAddress.address_2 || ""
                        }, ${orgData.billingAddress.city || ""}, ${
                        getStateFullName(
          orgData.billingAddress.country || "",
          orgData.billingAddress.state || ""
        )
                        }, ${getCountryFullName(orgData.billingAddress.country || "")}, ${
        orgData.billingAddress.postcode || ""
      }`
                      : "N/A"}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}{" "}
      {addMember && (
        <div className="fixed inset-0 flex items-center justify-center  bg-black bg-opacity-30 z-50">
          <div className="bg-white rounded-2xl p-6  w-[379px]  max-w-md relative">
            {/* Modal header */}
            <div className="flex items-center mb-1 justify-between">
              <div>
                <h2 className="text-[24px] nunito-semibold  text-[#0A0A0A">
                  Add Member
                </h2>
              </div>
              {/* Close button */}
              <div>
                <button
                  onClick={onClose}
                  className="   text-[#344054] hover:text-gray-700"
                >
                  <X className="w-[20px] h-[20px]" />
                </button>
              </div>
            </div>
            <p className="text-[#344054] text-[16px] nunito-regular mb-3">
              Enter email address to send the invitation link.
            </p>

            <form onSubmit={handleSubmitInvite}>
              {/* Email input */}
              <div className="mb-4">
                {/* Display general error message */}
                {formErrors.general && (
                  <div className="mb-1  ">
                    <p className="text-red-600 text-[14px] nunito-medium">
                      {formErrors.general}
                    </p>
                  </div>
                )}
                <label className="block text-[16px] nunito-semibold text-[#404040] mb-1">
                  Email
                </label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter email"
                  className={`w-full p-2 border ${
                    formErrors.general ? "border-red-500" : "border-[#D7DEDD]"
                  } rounded-[6px] text-[#404040] text-[14px] nunito-normal focus:outline-none focus:ring-2`}
                  required
                  disabled={isInviting}
                />
              </div>

              {/* Role dropdown */}
              <div className="mb-6">
                <label className="block text-[16px] nunito-semibold text-[#404040] mb-1">
                  Role
                </label>
                <div className="relative" ref={roleDropdownRef}>
                  <button
                    type="button"
                    className="w-full p-2 border border-[#D9D9D9] rounded-[8px] text-left text-[#404040] text-[14px] nunito-normal focus:outline-none focus:ring-2 focus:ring-orange-500 flex justify-between items-center"
                    onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                    disabled={isInviting}
                  >
                    {role
                      ? roles.find((r) => r.value === role)?.label ||
                        "Select role"
                      : "Select role"}
                    <svg
                      className="w-4 h-4 ml-2"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M19 9l-7 7-7-7"
                      />
                    </svg>
                  </button>{" "}
                  {isDropdownOpen && (
                    <div className="absolute z-10 mt-2 w-full bg-white border border-[#696969] text-[#404040] text-[14px] nunito-semibold rounded-[8px] shadow-lg">
                      {user?.teamRole === "expert_owner" && (
                        <div
                          className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                          onClick={() => {
                            setRole("teamLead");
                            setIsDropdownOpen(false);
                          }}
                        >
                          Team Lead
                        </div>
                      )}

                      <div
                        className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                        onClick={() => {
                          setRole("teamMember");
                          setIsDropdownOpen(false);
                        }}
                      >
                        Team Member
                      </div>
                    </div>
                  )}
                </div>
              </div>

              {/* Invite button */}
              <div className=" justify-center flex">
                <button
                  type="submit"
                  className={`bg-[#F15D18] hover:bg-orange-600 text-white px-6 py-2 rounded-md font-medium transition-colors ${
                    !isInviteFormValid || isInviting
                      ? "opacity-50 cursor-not-allowed"
                      : ""
                  }`}
                  disabled={!isInviteFormValid || isInviting}
                >
                  {isInviting ? "Processing... " : "Invite"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
      {/* Invite Success Modal */}
      {inviteSuccess && (
        <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg w-[450px] p-6 relative text-center shadow-lg">
            {/* Close Button */}
            <button
              onClick={() => setInviteSuccess(false)}
              className="absolute top-3 right-3 text-gray-500 hover:text-gray-700"
            >
              <X size={24} />
            </button>

            {/* Check Icon */}
            <div className="flex justify-center mt-1">
              <div className="bg-[#4BB847] border-gray-100 border-[10px] rounded-full p-4 flex items-center justify-center">
                <Check className="text-white w-[80px] h-[80px]" />
              </div>
            </div>
            <div className=" flex justify-center ">
              {/* Success Message */}
              <p className="  text-[#404040] w-[280px] text-[24px] mt-1 nunito-semibold">
                Team Member Successfully Added
              </p>
            </div>
            <button
              className="bg-[#F15D18] mt-2 w-[118px] text-[#FFFFFF] nunito-semibold h-[44px] text-[18px] rounded-md"
              onClick={() => {
                setInviteSuccess(false);
                setAddMember(true);
              }}
            >
              Add More
            </button>
          </div>
        </div>
      )}
      {viewEditeModel && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white rounded-xl shadow-lg w-[832px] max-h-[90vh] flex flex-col overflow-y-auto p-3">
            <div className="flex justify-between items-center mb-3">
              <h2 className="text-xl font-semibold">Edit - Member</h2>
              <button
                onClick={() => {
                  setViewEditeModel(false);
                  setEditedMemberId(null);
                  setViewedMemberId(null); // Reset viewed member ID
                }}
                className="text-gray-500 hover:text-gray-700"
              >
                <X size={24} />
              </button>
            </div>
            <div className="p-4 border rounded-lg">
              <div className="grid grid-cols-8 ">
                {/* Profile Image - Takes 1 column on the left */}
               <div className="mb-6 flex justify-start">
                               <div className="relative  h-20">
                                <div className="w-[80px] h-[80px] rounded-full overflow-hidden bg-gray-200 flex items-center justify-center">
                                  {selectedMember?.profileData?.profileImageUrl ? (
                                    <img
                                      src={selectedMember?.profileData?.profileImageUrl}
                                      alt="Profile"
                                      className="w-full h-full rounded-full object-cover"
                                    />
                                  ) : (
                                    <div className="w-full h-full bg-[#F15D18] rounded-full flex items-center justify-center text-white text-xl font-bold">
                                      {selectedMember?.profileData?.name
                                        ?.split(" ")
                                        .map((part: string) => part.charAt(0).toUpperCase())
                                        .join("") || "U"}
                                    </div>
                                  )}
                                </div>
                                <label className="absolute bottom-0 right-0 bg-[#F15D18] text-white p-1 disabled:cursor-not-allowed rounded-full cursor-pointer">
                                  <Camera className="w-4 h-4" />
                                  <input
                                    type="file"
                                    className="hidden"
                                    accept="image/*"
                                    onChange={handleImageUpload}
                                    disabled={uploadingImage}
                                  />
                                </label>
                                 {uploadingImage && (
                                                              <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50 rounded-full">
                                                                <Loader
                                                                  className="animate-spin text-white"
                                                                  size={24}
                                                                />
                                                              </div>
                                                             )} 
                              </div>
                              </div>

                {/* Form Content - Takes 3 columns on the right */}
                <div className="col-span-7 ">
                  {" "}
                  <div className="flex items-center mb-4">
                    {" "}
                    <h1 className="text-[20px] mr-4 text-[#404040] nunito-semibold">
                      Account Status
                    </h1>
                    <span className="font-medium mr-3">
                      {selectedMember?.userData?.disabled
                        ? "Deactivated"
                        : "Active"}
                    </span>
                    <div
                      className={`relative w-12 h-6 rounded-full ${
                        selectedMember?.userData?.disabled
                          ? "bg-gray-300"
                          : "bg-green-500"
                      } cursor-pointer`}
                      onClick={() =>
                        handleAccountStatusToggle(
                          selectedMember?.id || selectedMember?.uid,
                          selectedMember?.userData?.disabled
                        )
                      }
                      style={{ opacity: statusLoading ? 0.5 : 1 }}
                    >
                      <div
                        className={`absolute top-1 h-4 w-4 rounded-full bg-white transition-all ${
                          selectedMember?.userData?.disabled
                            ? "left-1"
                            : "left-7"
                        }`}
                      ></div>
                    </div>
                  </div>
                  <div className="grid grid-cols-2 gap-6 mb-6">
                    <div>
                      <label className="block mb-2 text-[#404040] nunito-semibold">
                        Full Name
                      </label>
                      <input
                        type="text"
                        name="fullName"
                        value={formData.fullName}
                        onChange={handleInputChange}
                        disabled={isSavingMember}
                        className="w-full px-3 py-2 border border-[#696969] rounded-[6px] focus:outline-none focus:ring-2 focus:ring-blue-500"
                      />
                    </div>
                    <div>
                      <label className="block mb-2 text-[#404040] nunito-semibold">
                        Email
                      </label>
                      <input
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleInputChange}
                        disabled
                        className="w-full px-3 py-2 border border-[#696969] rounded-[6px] focus:outline-none focus:ring-2 focus:ring-blue-500"
                      />
                    </div>
                  </div>
                  <div className="grid grid-cols-2 gap-6 mb-6">
                    <div>
                      <label className="block mb-2 text-[#404040] nunito-semibold">
                        Rate per min
                      </label>
                      <input
                        type="number"
                        name="ratePerMin"
                        value={formData.ratePerMin}
                        onChange={handleInputChange}
                        disabled={isSavingMember}
                        className="w-full px-3 py-2 border border-[#696969] rounded-[6px] focus:outline-none focus:ring-2 focus:ring-blue-500"
                      />
                    </div>
                    <div>
                      <label className="block mb-2 text-[#404040] nunito-semibold">
                        Role
                      </label>
                      <div className="relative">
                        <select
                          name="role"
                          value={formData.role}
                          onChange={handleInputChange}
                          disabled={isSavingMember}
                          className="w-full px-3 py-2 border border-[#696969] rounded-[6px] focus:outline-none focus:ring-2 focus:ring-blue-500"
                        >
                          <option value="expert_team_lead">Team Lead</option>
                          <option value="expert_team_member">
                            Team Member
                          </option>
                        </select>
                        <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none"></div>
                      </div>
                    </div>
                  </div>{" "}
                  <div className="mb-6">
                    <h3 className=" mb-4 text-[#696969] text-[20px] nunito-semibold">
                      Specialties
                    </h3>
                    <div className="grid grid-cols-2 gap-y-3">
                      {mergedSpecialties.map((specialty, index) => (
                        <div key={specialty} className="flex items-center">
                          <input
                            type="checkbox"
                            id={`specialty-${index}`}
                            name={specialty}
                            checked={formData.specialities[specialty] || false}
                            onChange={handleCheckboxChange}
                            disabled={isSavingMember}
                            className={`w-4 h-4 ${
                              formData.specialities[specialty]
                                ? "bg-[#F15D18] border-[#F15D18] text-white"
                                : "border-[#D9D9D9]"
                            } rounded focus:ring-orange-500 focus:ring-offset-0 cursor-pointer appearance-none border checked:bg-orange-500 transition-colors duration-200 ease-in-out`}
                            style={{
                              backgroundImage: formData.specialities[specialty]
                                ? "url(\"data:image/svg+xml,%3csvg viewBox='0 0 16 16' fill='white' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M12.207 4.793a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-2-2a1 1 0 011.414-1.414L6.5 9.086l4.293-4.293a1 1 0 011.414 0z'/%3e%3c/svg%3e\")"
                                : "",
                              backgroundSize: "100% 100%",
                              backgroundPosition: "center",
                              backgroundRepeat: "no-repeat",
                            }}
                          />
                          <label
                            htmlFor={`specialty-${index}`}
                            className="ml-2 text-[14px] nunito-regular text-[#404040] nunito-regular cursor-pointer"
                          >
                            {specialty}
                          </label>
                        </div>
                      ))}
                    </div>
                  </div>
                  {/* Only show "Others (Specify)" input field when "Others (Specify)" checkbox is checked */}
                  {formData.specialities["Others (Specify)"] && (
                    <>
                      <div className="mb-">
                        <label className="block mb-2 text-[#404040] text-[14px] nunito-regular">
                          Others (Specify)
                        </label>
                        <input
                          type="text"
                          name="otherSpecialties"
                          value={formData.otherSpecialties}
                          onChange={(e) => {
                            handleInputChange(e);
                            setCustomSpecialtyError("");
                          }}
                          disabled={isSavingMember}
                          placeholder="Please specify your other specialties"
                          className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                      </div>
                      {customSpecialtyError && (
                        <div className="mb-6">
                          <span className="text-red-500 text-[13px]">
                            {customSpecialtyError}
                          </span>
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>

            <div className="flex mt-3 justify-center">
              <button
                onClick={onSave}
                className="px-2 py-2 w-[120px]  justify-center h-[40px] bg-[#F15D18] text-[#FFFFFF] text-[16px] nunito-semibold rounded-[8px] hover:bg-orange-600 focus:outline-none focus:ring-2 focus:ring-orange-500 disabled:bg-gray-400 disabled:cursor-not-allowed flex items-center"
                disabled={isSavingMember}
              >
                {isSavingMember ? (
                  <span className="loader mr-2 w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
                ) : null}
                Save
              </button>
            </div>
          </div>
        </div>
      )}{" "}
      {/* Replace the old activity view modal with ViewModel component */}
      {viewModelOpen && selectedActivity && (
        <ViewModel
          isOpen={viewModelOpen}
          onClose={handleActivityClose}
          activityTitle={`${selectedActivity.id || ""}`}
          expertName={
            selectedActivity.expertData?.name ||
            selectedActivity.expertName ||
            ""
          }
          expertEmail={
            selectedActivity.expertData?.email ||
            `${(
              selectedActivity.expertData?.name ||
              selectedActivity.expertName ||
              ""
            )
              .toLowerCase()
              .replace(/\s+/g, "")}@gmail.com`
          }
          expertRating={selectedActivity.expertRating}
          expertRatingUser={
            userRatings[
              selectedActivity.expertId || selectedActivity.expertData?.id
            ]?.avgRating?.toFixed(1) || 0
          }
          expertReviewCount={
            userRatings[selectedActivity.expertId]?.totalReviews || 0
          }
          customerName={
            selectedActivity.customerData?.name ||
            selectedActivity.customerName ||
            ""
          }
          customerEmail={
            selectedActivity.customerData?.email ||
            `${(
              selectedActivity.customerData?.name ||
              selectedActivity.customerName ||
              ""
            )
              .toLowerCase()
              .replace(/\s+/g, "")}@gmail.com`
          }
          customerRatingUser={
            userRatings[
              selectedActivity.customerId || selectedActivity.customerData?.id
            ]?.avgRating?.toFixed(1) || 0
          }
          customerRating={selectedActivity.customerRating}
          customerReviewCount={
            userRatings[
              selectedActivity.customerId || selectedActivity.customerData?.id
            ]?.totalReviews || 0
          }
          activityType={selectedActivity.activityType || "Chat"}
          activityTime={(() => {
            if (selectedActivity.startTime?.seconds) {
              return (
                new Date(
                  selectedActivity.startTime.seconds * 1000
                ).toLocaleDateString("en-US", {
                  month: "2-digit",
                  day: "2-digit",
                  year: "numeric",
                }) +
                ", " +
                new Date(
                  selectedActivity.startTime.seconds * 1000
                ).toLocaleTimeString("en-US")
              );
            } else if (selectedActivity.createdAt?.seconds) {
              return (
                new Date(
                  selectedActivity.createdAt.seconds * 1000
                ).toLocaleDateString("en-US", {
                  month: "2-digit",
                  day: "2-digit",
                  year: "numeric",
                }) +
                ", " +
                new Date(
                  selectedActivity.createdAt.seconds * 1000
                ).toLocaleTimeString("en-US")
              );
            }
            return selectedActivity.startTime || "";
          })()}
          activityDuration={(() => {
            const duration = selectedActivity.duration;
            if (!duration) return "- mins";

            if (typeof duration === "object" && duration.hours !== undefined) {
              const { hours = 0, minutes = 0, seconds = 0 } = duration;
              if (hours > 0) {
                return `${hours}h ${minutes}m`;
              } else if (minutes > 0) {
                return `${minutes}m ${seconds}s`;
              } else {
                return `${seconds}s`;
              }
            }

            if (typeof duration === "number") {
              return `${duration} mins`;
            }

            if (typeof duration === "string") {
              return duration.includes("min") ? duration : `${duration} mins`;
            }

            return "- mins";
          })()}
          activityCost={
           Number(selectedActivity.cost ?? 0).toFixed(2)
            
           
          }
          activitySavings={selectedActivity.refundAmount || "0"}
          onEditActivity={handleActivityEditFromViewModel}
          activityData={selectedActivity} // Pass the complete activity data
          expertOrgName={expertOrgName}
          customerOrgName={customerOrgName}
          expertTeamName={expertTeamName}
          customerTeamName={customerTeamName}
          expertteamRole={selectedActivity.expertData?.teamRole || ""}
          customerTeamRole={selectedActivity.customerData?.teamRole || ""}
        />
      )}
      
    </Layout>
  );
};

export default Teams;
